import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  default as Button,
  default as CustomButton,
} from "../components/Button";
import { serverBaseUrl } from "../config/envs";
import {
  CLOSE_SIGNATURE_MODAL,
  OPEN_SIGNATURE_MODAL,
  REMOVE_SIGNATURE,
  UPLOAD_SIGNATURE_FILE,
} from "../redux/actions/actionTypes";
import { UPDATE_ADMIN_FORM_ERROR } from "../redux/actions/formActions";
import { getFormattedDate } from "../utils/dateFormate";
import GFEForm from "./GFEForm";
import SignatureComponent from "./Signature";
import SignatureModal from "./SignatureModal";

const QualiphyServiceAgreement = ({ data, scrollToNext, signedDoc }) => {
  const adminFormErrors = useSelector((state) => state?.form?.adminFormErrors);
  const { signSecretId } = useParams();

  const [formData, setFormData] = useState({
    presidentTitle: "",
    dateSigned: "",
    practiceName: data.data?.qualiphy_clinic_name,
    signature: "",
    name: "",
    title: "Mr",
    practiceNameforSignature: "",
    cardHolderDate: "",
    qualiphyPcName: "Qualiphy PC",
    by: "",
  });
  const dispatch = useDispatch();
  const signature = useSelector((state) => state?.signature);
  const { loading, open } = signature;
  const [currentDate, setCurrentDate] = useState();
  const [signType, setSignType] = useState("");
  const [userSignauter, setUserSignautre] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 640);
  // Function to handle the button click for selecting a signature type

  const [filledSignatureIds, setFilledSignatureIds] = useState([]);

  const [signImage, setSignImages] = useState(null);

  const handleChangeError = (key, value) => {
    dispatch({
      type: UPDATE_ADMIN_FORM_ERROR,
      payload: { key, value },
    });
  };

  const handleOnSignatureClick = useCallback(() => {
    if (signImage) {
      setFilledSignatureIds([...filledSignatureIds, "signature_2"]);
    } else {
      dispatch({
        type: OPEN_SIGNATURE_MODAL,
      });
      setFilledSignatureIds([...filledSignatureIds, "signature_2"]);
    }
    handleChangeError("signature_2", null);
  }, [signature, signImage, filledSignatureIds]);

  useEffect(() => {
    const handleResize = () => setIsLargeScreen(window.innerWidth >= 640);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleModalClose = () => {
    dispatch({ type: CLOSE_SIGNATURE_MODAL });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    setCurrentDate(getFormattedDate());
  }, [currentDate]);

  const uploadSignatureFile = useCallback(
    async (file) => {
      dispatch({
        type: UPLOAD_SIGNATURE_FILE,
        payload: { file: file, signSecretId, existingSignatureUrl: signImage },
      });
    },
    [signImage]
  );

  const removeSignature = async (file) => {
    setIsLoading(true);
    let _payLoad = {
      signerId: data.data?.signers[0]?.id,
      clinicId: data?.data?.qualiphy_clinic_id,
      signSecretId: signSecretId,
    };
    dispatch({
      type: REMOVE_SIGNATURE,
      payload: _payLoad,
    });
  };

  useEffect(() => {
    if (signedDoc.length) {
      setSignImages(signedDoc[0]?.url);
    } else {
      setSignImages(null);
    }
  }, [signedDoc]);

  useEffect(() => {
    if (signSecretId && data?.data) {
      getAdminSignature();
    }
  }, [signSecretId, data]);

  const getAdminSignature = useCallback(async () => {
    if (data?.data?.signers[0]?.id) {
      try {
        const response = await axios.get(
          `${serverBaseUrl}/get_signature?signerId=${data?.data?.signers[0]?.id}`,
          {
            headers: {
              "sign-secret-id": signSecretId,
            },
          }
        );

        if (response?.data?.data[0]?.url) {
          setSignImages(response?.data?.data[0]?.url);
        } else {
          setSignImages(null);
        }
      } catch (error) {
        console.error("Get signature error:", error);
        setSignImages(null);
      }
    }
  }, [data, signSecretId]);

  return (
    <div className="mt-10 max-w-4xl w-full space-y-6 bg-white border overflow-hidden rounded-xl shadow-lg flex flex-col border-1 border-gray-900">
      {data?.data?.consent && isLargeScreen && (
        <div className="z-50 mt-3 hidden md:hidden lg:block fixed top-25   -ml-20">
          <Button
            backgroundColor="rgb(207 201 255)"
            labelColor="black"
            className="h-10 border-0 border-white-600"
            label="Fill In"
            onClick={scrollToNext}
            top={3}
          />
        </div>
      )}

      <div className="bg-white text-gray-900 space-y-4 px-6">
        <>
          <style
            type="text/css"
            dangerouslySetInnerHTML={{
              __html:
                '\n\t\t@page { size: 8.5in 11in; margin-left: 1in; margin-right: 1in; margin-top: 1in; margin-bottom: 0.5in }\n\t\tp { color: #000000; line-height: 0in; text-align: justify; orphans: 0; widows: 0; text-indent: -0in; margin-left: -0in; margin-bottom: 0in; direction: ltr; background: transparent }\n\t\tp.western { font-family: "Times New Roman", serif }\n\t\th2 { color: #000000; line-height: 0in; text-align: justify; page-break-inside: avoid; orphans: 2; widows: 2; text-indent: -0in; margin-left: -0in; margin-top: 0.14in; margin-bottom: 0in; direction: ltr; background: transparent; page-break-after: avoid }\n\t\th2.western { font-family: "Cambria", serif; font-size: 13pt; font-weight: bold }\n\t\th2.cjk { font-family: "Times New Roman"; font-size: 13pt; font-weight: bold }\n\t\th2.ctl { font-family: "Times New Roman"; font-size: 13pt; font-weight: bold }\n\t\ta:link { color: #000000; text-decoration: none }\n\t\ta:visited { color: #000000; text-decoration: underline }\n\t\ta.sdfootnotesym { color: #000000; text-decoration: none }\n\t\ta.sdendnotesym { color: #000000; text-decoration: none }\n\t',
            }}
          />

          <div>
            <a name="bookmark=id.gjdgxs" />
            <span style={{ fontVariant: "small-caps" }}>
              <font face="Times New Roman, serif">
                <b>QUALIPHY SERVICES AGREEMENT</b>
              </font>
            </span>
          </div>
          <div className="text-justify">
            <font face="Arial, sans-serif">
              <font face="Times New Roman, serif">
                This Professional Services Agreement (this “
              </font>
              <font face="Times New Roman, serif">
                <b>Agreement</b>
              </font>
              <font face="Times New Roman, serif">
                ”), effective as of the date the Agreement is signed by both
                parties (the “
              </font>
              <font face="Times New Roman, serif">
                <b>Effective Date</b>
              </font>
              <font face="Times New Roman, serif">
                ”), is by and between Qualiphy PC, a California professional
                medical corporation, with offices located at 113 N. San Vicente
                Blvd 3rd Floor, Beverly Hills, CA 90211 (“
              </font>
              <font face="Times New Roman, serif">
                <b>Qualiphy</b>
              </font>
              <font face="Times New Roman, serif">
                ”) and the medical practice named on the signature page hereto
                (“
              </font>
              <font face="Times New Roman, serif">
                <b>Practice</b>
              </font>
              <font face="Times New Roman, serif">
                ”). Qualiphy and Practice are each referred to herein
                individually as a “
              </font>
              <font face="Times New Roman, serif">
                <b>Party</b>
              </font>
              <font face="Times New Roman, serif">
                ” and collectively as the “
              </font>
              <font face="Times New Roman, serif">
                <b>Parties</b>
              </font>
              <font face="Times New Roman, serif">”.</font>
            </font>
          </div>
          <p
            className="western text-justify"
            align="center"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <a name="bookmark=id.30j0zll" />
            <font face="Arial, sans-serif">
              <font face="Times New Roman, serif">
                <b>BACKGROUND</b>
              </font>
            </font>
          </p>
          <ol type="A">
            <li>
              <p
                className="western text-justify"
                align="justify"
                style={{
                  lineHeight: "100%",
                  orphans: 2,
                  widows: 2,
                  textIndent: "0in",
                  marginBottom: "0.17in",
                  border: "none",
                  padding: "0in",
                }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    Practice is a legally formed and qualified professional
                    entity rendering medical services through its employees
                    and/or independent medical providers who are duly licensed
                    to practice medicine and/or nursing in the state in which
                    Practice and its patients are located (the “
                  </font>
                  <font face="Times New Roman, serif">
                    <b>Practice State</b>
                  </font>
                  <font face="Times New Roman, serif">”).</font>
                </font>
              </p>
            </li>
            <li>
              <p
                className="western text-justify"
                align="justify"
                style={{
                  lineHeight: "100%",
                  orphans: 2,
                  widows: 2,
                  textIndent: "0in",
                  marginBottom: "0.17in",
                  border: "none",
                  padding: "0in",
                }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    Qualiphy is registered in the Practice State to render
                    medical services, including evaluating, via telemedicine,
                    through its licensed medical providers, whether patients of
                    the Practice are suitable candidates for the medical
                    services desired to be administered and prescribed by the
                    licensed providers of the Practice.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                className="western text-justify"
                align="justify"
                style={{
                  lineHeight: "100%",
                  orphans: 2,
                  widows: 2,
                  textIndent: "0in",
                  marginBottom: "0.17in",
                  border: "none",
                  padding: "0in",
                }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    Practice desires to engage Qualiphy for the purposes of
                    reviewing relevant patient history, conducting patient
                    examinations via telemedicine followed by any applicable
                    diagnosis (“
                  </font>
                  <font face="Times New Roman, serif">
                    <b>Patient Evaluation</b>
                  </font>
                  <font face="Times New Roman, serif">
                    ”) and providing treatment plan recommendation, if
                    applicable (“
                  </font>
                  <font face="Times New Roman, serif">
                    <b>Treatment Recommendation</b>
                  </font>
                  <font face="Times New Roman, serif">
                    ”) (collectively the “
                  </font>
                  <font face="Times New Roman, serif">
                    <b>Professional Screening Services</b>
                  </font>
                  <font face="Times New Roman, serif">
                    ”), where the actual ordering, prescribing and administering
                    of any recommended treatment will be reviewed and rendered
                    by the licensed providers of the Practice if the licensed
                    providers of the Practice deem appropriate in their sole
                    professional judgment.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                className="western text-justify"
                align="justify"
                style={{
                  lineHeight: "100%",
                  orphans: 2,
                  widows: 2,
                  textIndent: "0in",
                  marginBottom: "0.17in",
                  border: "none",
                  padding: "0in",
                }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    Qualiphy will only enter into this Agreement for Patient
                    Evaluation and Treatment Recommendation if the Practice is
                    appropriately formed and qualified in the Practice State and
                    has a medical director, and the Practice’s medical director
                    agrees to supervise and delegate the Professional Screening
                    Services as provided in this Agreement.
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              <font face="Times New Roman, serif">
                {" "}
                NOW, THEREFORE, for good and valuable consideration, the receipt
                and adequacy of which is hereby acknowledged, including the
                mutual covenants contained herein, the Parties desire to enter
                into this Agreement to set forth terms and conditions related to
                Qualiphy’s relationship with the Practice as an independent
                contractor.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="center"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              <font face="Times New Roman, serif">
                <b>AGREEMENT</b>
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              1.
              <font face="Times New Roman, serif">
                <u>
                  <b>Qualiphy’s Professional Screening Services</b>
                </u>
              </font>
              <font face="Times New Roman, serif">.</font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              1.1
              <font face="Times New Roman, serif">
                Practice engages Qualiphy to provide Professional Screening
                Services through its licensed medical providers, consistent with
                the requirements of state and federal law. Qualiphy will perform
                the Professional Screening Services in a competent and
                professional manner. Qualiphy will not be required to perform
                services that violate the law or in Qualiphy’s sole discretion,
                any other ethical considerations, or that are inconsistent with
                the Parties’ rights and obligations under this Agreement.{" "}
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              1.2
              <font face="Times New Roman, serif">
                Qualiphy providers will be appropriately licensed and supervised
                in the Practice State and will meet the applicable standard of
                care applicable to the Professional Screening Services being
                provided.{" "}
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              1.3
              <font face="Times New Roman, serif">
                All Professional Screening Services will be provided via
                telemedicine. Qualiphy providers will establish a valid
                patient-provider relationship via telemedicine pursuant to all
                applicable local, state, and federal laws, regulations, and
                professional standards with the patient. Qualiphy providers will
                be located in a private HIPAA compliant environment. Once
                Practice enters the Qualiphy HIPAA compliant application for
                both the and the patient’s demographics, the Qualiphy provider
                will connect the telemedicine appointment and conduct the
                Professional Screening Services. The Professional Screening
                Services will include the following:
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              (a)
              <font face="Times New Roman, serif">
                Obtaining patient medical history and performing patient
                examination via telemedicine adequate to establish the diagnosis
                and recommendation of a treatment plan, where applicable; and
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              (b)
              <font face="Times New Roman, serif">
                Having sufficient dialogue with the patient regarding treatment
                options and the risks and benefits of treatment.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              1.4
              <font face="Times New Roman, serif">
                For each medical procedure being screened for, Qualiphy
                maintains a list of necessary medical history questions and
                screening criteria, including contraindications. It is the
                responsibility of Practice to determine whether Qualiphy’s
                screening questions and criteria are sufficient. Practice will
                be able to add any additional questions or criteria to the
                standard screening exam for each procedure.{" "}
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              1.5
              <font face="Times New Roman, serif">
                Qualiphy providers, in their sole discretion, may determine that
                examination vis telemedicine is not sufficient and that a
                patient requires in-person examination in order to establish a
                diagnosis or recommend a treatment plan. In such case, there is
                no refund of any fees paid to Qualiphy for the Professional
                Screening Services.{" "}
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              1.6
              <font face="Times New Roman, serif">
                Following completion of Professional Screening Services for a
                patient, Qualiphy will provide Practice with a note documenting
                the Patient Evaluation results along with the Treatment
                Recommendation, if applicable. Treatment Recommendation may not
                be provided if, in the Qualiphy provider’s sole professional
                determination, telemedicine screening was not sufficient, and
                the patient required in-person examination. Treatment
                Recommendations may be made directly in the Practice’s
                electronic medical record if Qualiphy is given access or may be
                downloaded by Practice, signed by Practice's medical director,
                and added to the patient's record.{" "}
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              1.7
              <font face="Times New Roman, serif">
                Treatment Recommendations will likely be valid for up to one
                year from the date of the Patient Evaluation, unless state law,
                patient's medical history or treatment plan dictates otherwise.
                If the patient returns to the Practice for a different treatment
                and would require a different treatment plan or experiences a
                substantive change in their health or medication regimen since
                the Patient Evaluation, the original Patient Evaluation and
                Treatment Recommendation provided will not be applicable and the
                patient will require a new Patient Evaluation. It is the
                responsibility of the Practice’s licensed providers to ensure
                that nothing has changed in the patient’s health history since
                the date of the Initial Evaluation that would make a Treatment
                Recommendation inappropriate or inapplicable. If the Treatment
                Recommendation approves use of a medical device by Practice,
                then Practice must refer to Practice’s device manufacture
                guidelines for operation of the device.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              1.8
              <font face="Times New Roman, serif">
                Qualiphy will not treat any of the Practice’s patients. Qualiphy
                providers are solely reviewing relevant patient history,
                conducting patient examinations via telemedicine followed by any
                applicable diagnosis and providing a treatment plan
                recommendation, if applicable. The actual ordering, prescribing
                and administering of any Treatment Recommendation is reviewed
                and rendered by the licensed providers of the Practice if the
                licensed providers of the Practice deem appropriate in their
                sole professional judgment. As such, Practice must confirm with
                proper standing orders and policies that treatment is rendered
                by a licensed and appropriately supervised provider of the
                Practice who has an ongoing professional relationship with the
                patient. Qualiphy does not prescribe any medications or provide
                any on-call or emergency services or participate in on-going
                treatment of the patient.{" "}
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              1.9
              <font face="Times New Roman, serif">
                Qualiphy represents to Practice that all its providers are and
                at all times during the term of this Agreement will remain
                licensed as medical providers in the Practice State. Qualiphy
                further represents to Practice that all of its providers’
                licenses and privileges to engage in the practice of medicine or
                nursing, as applicable, are in good standing. Notwithstanding
                the above, Practice acknowledges and agrees that Qualiphy
                providers may not prescribe medication in any Treatment
                Recommendation. Qualiphy will, upon reasonable request of the
                Practice, provide Practice with a copy of the state medical or
                nursing license for each provider that Qualiphy provides to
                Practice for purposes of telemedicine good faith exam with
                Practice’s patients.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <a name="bookmark=id.1fob9te" />
            <font face="Arial, sans-serif">
              1.10
              <font face="Times New Roman, serif">
                Qualiphy maintains adequate professional liability insurance as
                required by applicable law on behalf of each of its providers
                and will continue to do so throughout the Term of this
                Agreement. Such insurance will have limits no less than one
                million dollars ($1,000,000) per claim and no less than three
                million dollars ($3,000,000) in the aggregate for any policy
                year and be the primary liability insurance related to providers
                provided by Qualiphy regardless of any secondary insurance that
                may be obtained by Practice, in its sole discretion, with
                respect to the providers. Upon Practice’s request, Qualiphy will
                provide proof of such insurance.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              2.
              <font face="Times New Roman, serif">
                <u>
                  <b>Practice’s Obligations</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                . As consideration to Qualiphy for making providers available to
                Practice for the Professional Screening Services, and in
                addition to the payment terms set forth herein and on Exhibit A,
                throughout the Term of this Agreement, Practice agrees as
                follows:
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              2.1
              <font face="Times New Roman, serif">
                Practice confirms that Practice has a licensed Medical Director
                overseeing all medical treatments.{" "}
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              2.2
              <font face="Times New Roman, serif">
                Practice will, at all times during which Professional Screening
                Services are provided by Qualiphy, have a physician, registered
                nurse (RN), nurse practitioner (NP), other advanced practice
                registered nurse (APRN), or physician assistant (PA) licensed in
                the Practice State, in good standing, on staff (“
              </font>
              <font face="Times New Roman, serif">
                <b>Practice Providers</b>
              </font>
              <font face="Times New Roman, serif">
                ”) to assist the Qualiphy provider with provision of the
                Professional Screening Services. The costs and expenses of such
                Practice Providers including, without limitation, salary,
                benefits, and vacation/sick pay, will be borne exclusively by
                the Practice. Any non-physician Practice Providers must be
                appropriately supervised by the Medical Director in accordance
                with state law.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              2.3
              <font face="Times New Roman, serif">
                Practice will, at all times during which Professional Screening
                Services are provided by Qualiphy, have at least one functioning
                computer and color printer with high-speed Internet access.
                Practice must have at least one functioning webcam camera with
                microphone and speakers at the Practice site or a mobile device
                that provides equivalent functionality that comply with all
                applicable state telemedicine laws.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              2.4
              <font face="Times New Roman, serif">
                Practice will keep and maintain appropriate and accurate
                records, reports, claims, and correspondence in connection with
                all services rendered by Practice for all patients for which
                Qualiphy has provided Professional Screening Services consistent
                with applicable state and federal law.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              2.5
              <font face="Times New Roman, serif">
                Practice represents and warrants that Medical Director has
                written, reviewed and approved protocols for all Qualiphy
                screening procedures being performed at Practice. Any custom
                evaluation created for Practice within Qualiphy portal, has been
                written, reviewed and approved by Medical Director, and such
                protocols will be adhered to and followed meticulously in
                accordance with state and federal law. Custom exams are defined
                as any exam created by the Practice, which has the ability to be
                edited by the Practice. For the avoidance of doubt, any
                evaluation that does not come standard with Qualiphy or is
                created by Qualiphy and available to any Practice using Qualiphy
                is considered a custom exam. The Practice and its Medical
                Director acknowledge that they are solely responsible for the
                content, accuracy, medical liability and legal compliance of any
                custom exams they create or edit. The Practice and Medical
                Director agree to indemnify and hold harmless Qualiphy PC and
                its providers from any claims, liabilities, or issues arising
                out of or related to the use of custom exams created or edited
                by the Practice.
              </font>
            </font>
          </p>
          <div
            className="text-justify mt-2 mb-4"
            style={{
              textIndent: "-0in",
              marginLeft: "0in",
            }}
          >
            <div className="text-gray-800">
              <span className="font-sans">2.6</span>{" "}
              <span className="font-serif">
                Practice will share and maintain appropriate and accurate
                records, reports, claims, and correspondence with Medical
                Director or Supervising On-Site Physician prior to any treatment
                provided, including approved and denied exams, reviewing each
                answer in connection with all services rendered by Practice for
                all patients for which Qualiphy has provided Professional
                Screening Services consistent with applicable state and federal
                law.
              </span>
            </div>
          </div>

          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              2.7
              <font face="Times New Roman, serif">
                As set forth above, for each medical procedure being screened
                for, Qualiphy maintains a list of necessary medical history
                questions and screening criteria, including contraindications.
                It is the responsibility of Practice to determine whether
                Qualiphy’s screening questions and criteria are sufficient.
                Practice will be able to add any additional questions or
                criteria to the standard screening exam for each procedure.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              2.8
              <font face="Times New Roman, serif">
                It is the responsibility of the Practice’s licensed providers to
                ensure that nothing has changed in the patient’s health history
                since the date of the Treatment Recommendation prior to
                treatment being provided.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              2.9
              <font face="Times New Roman, serif">
                Practice must maintain adequate professional liability insurance
                as required by applicable law on behalf of each of its providers
                and must continue to do so throughout the Term of this
                Agreement. Such insurance must have limits no less than one
                million dollars ($1,000,000) per claim and no less than three
                million dollars ($3,000,000) in the aggregate for any policy
                year and be the primary liability insurance related to
                Practice’s providers. Upon Qualiphy’s request, Practice will
                provide proof of such insurance.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              2.10
              <font face="Times New Roman, serif">
                <u>
                  <b>
                    Practice’s Obligations with Respect to Practice’s Medical
                    Director.
                  </b>
                </u>
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              (a)
              <font face="Times New Roman, serif">
                Practice confirms that the Practice’s medical director (the “
              </font>
              <font face="Times New Roman, serif">
                <b>Medical Director</b>
              </font>
              <font face="Times New Roman, serif">
                ”) has the required education, training, and expertise as it
                relates to medical services provided by the Practice.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              (b)
              <font face="Times New Roman, serif">
                Practice must inform Qualiphy of any change to Practice’s
                Medical Director within five business days of such change.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              (c)
              <font face="Times New Roman, serif">
                In the event of any change to Practice’s Medical Director,
                Practice must provide Qualiphy with all relevant information
                related to the newly appointed Medical Director, including but
                not limited to, name, address, dates of transition and medical
                director licensure status.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              (d)
              <font face="Times New Roman, serif">
                In the event, Practice does not timely replace a departed
                Medical Director, Qualiphy reserves the right to immediately
                cease Professional Screening Services until a new qualified
                medical director is appointed.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            style={{
              lineHeight: "95%",
              orphans: 0,
              widows: 0,
              textIndent: "-0in",
              marginLeft: "0in",
              marginRight: "0.1in",
              marginTop: "0.17in",
            }}
          >
            <font face="Arial, sans-serif">
              (e)
              <font face="Times New Roman, serif">
                Practice further agrees that any “custom” exam(s) created within
                the Qualiphy portal, have been written, reviewed and approved by
                the Medical Director.{" "}
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            style={{
              lineHeight: "95%",
              orphans: 0,
              widows: 0,
              textIndent: "-0in",
              marginLeft: "0in",
              marginRight: "0.1in",
              marginTop: "0.17in",
            }}
          >
            <br />
          </p>
          <p
            className="western text-justify"
            style={{
              lineHeight: "95%",
              orphans: 0,
              widows: 0,
              textIndent: "-0in",
              marginLeft: "0in",
              marginRight: "0.1in",
            }}
          >
            <a name="bookmark=id.3znysh7" />
            <font face="Arial, sans-serif">
              (f)
              <font face="Times New Roman, serif">
                Practice agrees to receive SMS message(s) from Qualiphy, and has
                written consent from patients to receive text message(s) from
                Qualiphy as it relates to medical screening.{" "}
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <a name="bookmark=id.2et92p0" />
            <font face="Arial, sans-serif">
              3.
              <font face="Times New Roman, serif">
                <u>
                  <b>Payment Terms</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                <b>.</b>
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              3.1
              <font face="Times New Roman, serif">
                In exchange for the Professional Screening Services provided by
                Qualiphy to the Practice, Practice agrees to pay to Qualiphy the
                per exam screening fee as set forth in Exhibit A. The per exam
                screening fee is subject to change on 30 days’ prior notice to
                Practice, and Qualiphy may charge a different rate for custom
                screening exams. At the conclusion of a patient screening,
                Qualiphy will charge the per patient screening fee to the
                Practice’s credit card on file.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              3.2
              <font face="Times New Roman, serif">
                Qualiphy may, in its sole discretion, also start charging a
                monthly membership/subscription fee at any time in addition to
                or instead of the per patient screening fee by providing written
                notice of such change at least thirty (30) days in advance. The
                amount of the monthly membership/subscription fee may also
                change in the future with at least 30 days prior notice to
                Practice.{" "}
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              3.3
              <font face="Times New Roman, serif">
                Practice agrees to complete the Credit Card Authorization
                attached hereto as part of Exhibit A and to provide a valid
                credit card on file. If any information changes to the credit
                card on file, Practice agrees to notify Qualiphy and provide
                updated credit card information. The individual signing the
                Credit Card Authorization must be an authorized representative
                and cardholder for the credit card. Practice understands that
                Qualiphy will charge the credit card on file for all payments
                due to Qualiphy according to the terms of this Agreement.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              3.4
              <font face="Times New Roman, serif">
                If there is a declined or failed payment, Qualiphy will notify
                Practice, and Practice will have a three-day deadline to make
                payment. If there is still no payment after three days, interest
                will begin accruing on the overdue amount at a rate of 5% per
                month until paid and no further screening services will be
                provided until a payment plus interest is paid and a valid
                credit card on file is provided.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              3.5
              <font face="Times New Roman, serif">
                Qualiphy will not directly bill any patient nor accept any
                payment from patient and all Qualiphy providers providing
                Professional Screening Services for Practice will be compensated
                by Qualiphy.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <a name="bookmark=id.tyjcwt" />
            <font face="Arial, sans-serif">
              4.
              <font face="Times New Roman, serif">
                <u>
                  <b>Term and Termination</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                <b>.</b>
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              4.1
              <font face="Times New Roman, serif">
                This Agreement will commence on the Effective Date and will
                continue in effect until terminated by either Qualiphy or
                Practice as set forth in this Section 4. The time period during
                which the Agreement is in effect is referred to herein as the “
              </font>
              <font face="Times New Roman, serif">
                <b>Term</b>
              </font>
              <font face="Times New Roman, serif">”.</font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <a name="bookmark=id.3dy6vkm" />
            <font face="Arial, sans-serif">
              4.2
              <font face="Times New Roman, serif">
                <u>
                  <b>Termination by Mutual Agreement</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                <b>.</b>
              </font>
              <font face="Times New Roman, serif">
                This Agreement will terminate immediately upon the mutual
                written agreement of the Parties.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <a name="bookmark=id.1t3h5sf" />
            <font face="Arial, sans-serif">
              4.3
              <font face="Times New Roman, serif">
                <u>
                  <b>Termination Without Cause</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                <b>.</b>
              </font>
              <font face="Times New Roman, serif">
                Either party, in its sole discretion, may terminate this
                Agreement at any time and for any reason by providing at least
                30 days’ prior written notice to the other Party. All fees must
                be paid through the termination date.{" "}
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              4.4
              <font face="Times New Roman, serif">
                <u>
                  <b>Termination by Qualiphy</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                . This Agreement may be immediately terminated by Qualiphy, by
                written notice to the Practice, upon the occurrence of any of
                the following:
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              (a)
              <font face="Times New Roman, serif">
                Practice does not have a Medical Director;
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              (b)
              <font face="Times New Roman, serif">
                Practice or any of its owners or employees are investigated,
                charged, sanctioned, or closed by any federal or the Practice
                State in which Practice operates agency with jurisdiction over
                the Practice, or by any medical or other government regulatory
                board;
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              (c)
              <font face="Times New Roman, serif">
                Practice or any of the owners of Practice are convicted in a
                criminal or civil proceeding of fraud, misappropriation,
                embezzlement, or the commission of a felony or of a
                narcotic-related offense or pleads nolo contendere to any such
                charge;
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              (d)
              <font face="Times New Roman, serif">
                Practice disputes any valid charges to Practice’s credit card on
                file;
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              (e)
              <font face="Times New Roman, serif">
                Practice breaches any material obligation or covenant under this
                Agreement, breaches any representation or warranty made by
                Practice, or fails to faithfully perform the services required
                by this Agreement; provided the Practice is first given written
                notice of default and ten business days to cure the alleged
                breach if able to be cured; or
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              (f)
              <font face="Times New Roman, serif">
                The liquidation or dissolution of Practice, the filing of a
                petition in bankruptcy with respect to the Practice or the
                Practice’s owners, the Practice’s or its owners’ application for
                or, consent to the appointment of a trustee, receiver or
                custodian for the Practice or its owners or a substantial part
                of its/their assets, or the entry of any order therefore, or the
                Practice’s or its owners’ making of any general assignment for
                the benefit of its creditors.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              4.5
              <font face="Times New Roman, serif">
                <u>
                  <b>Termination by Practice</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                . Practice may immediately terminate this Agreement by written
                notice to Qualiphy, upon the occurrence of any of the following:
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              (a)
              <font face="Times New Roman, serif">
                Qualiphy provides an unlicensed provider to provide Professional
                Screening Services to Practice;
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              (b)
              <font face="Times New Roman, serif">
                Qualiphy breaches any material obligation or covenant under this
                Agreement, or Qualiphy fails to faithfully perform the services
                required by this Agreement; provided Qualiphy is first given
                written notice of default and ten business days to cure the
                alleged breach if able to be cured;
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              (c)
              <font face="Times New Roman, serif">
                The filing of a petition in bankruptcy with respect to Qualiphy,
                Qualiphy’s application for or, consent to the appointment of a
                trustee, receiver or custodian for Qualiphy or a substantial
                part of Qualiphy’s assets, or the entry of any order therefore,
                or Qualiphy’s making of any general assignment for the benefit
                of its creditors; or
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <a name="bookmark=id.4d34og8" />
            <font face="Arial, sans-serif">
              (d)
              <font face="Times New Roman, serif">
                The dissolution of Qualiphy
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <a name="bookmark=id.2s8eyo1" />
            <font face="Arial, sans-serif">
              4.6
              <font face="Times New Roman, serif">
                <u>
                  <b>Effects of Termination or Expiration</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                . Upon termination of this Agreement, the Parties will not have
                any further rights, duties, or obligations under this Agreement,
                except as otherwise provided herein. The termination or
                expiration will not affect any liability or other obligation of
                the Parties that accrued prior to the termination or expiration.
                Any compensation owed to Qualiphy for Professional Screening
                Services provided by Qualiphy prior to the date of termination
                will remain payable to Qualiphy and will be charged to
                Practice’s credit card on file.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginTop: "0.17in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              5.
              <font face="Times New Roman, serif">
                <u>
                  <b>Business Associate Addendum</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                . Qualiphy and Practice agree to comply with all state and
                federal patient privacy and data laws, including but not limited
                the Health Insurance Portability and Accountability Act of 1996
                and all rules, regulations, and related laws and acts
                promulgated under and in connection with such Act (collectively,
                “
              </font>
              <font face="Times New Roman, serif">
                <b>HIPAA</b>
              </font>
              <font face="Times New Roman, serif">
                ”). The Parties therefore desire to enter into a Business
                Associate Addendum regarding the use and/or disclosure of
                Protected Health Information as required by HIPAA, as may be
                amended from time to time, which is attached as Exhibit B and
                incorporated by reference.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              6.
              <font face="Times New Roman, serif">
                <u>
                  <b>Notification of State or Federal Action or a Complaint</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                <b>.</b>
              </font>
              <font face="Times New Roman, serif">
                Qualiphy will notify Practice as soon as possible and within a
                reasonable time period, if any provider provided by Qualiphy to
                the Practice is disciplined concerning an allegation of
                professional misconduct, or if any provider provided by Qualiphy
                to the Practice otherwise loses a license to practice, or if any
                person files any type of complaint against any provider provided
                by Qualiphy to the Practice, whether in court or to a state
                body. Practice will immediately notify Qualiphy, in writing, if
                Practice or any of its employees or owners is investigated,
                indicted, or disciplined concerning violation of any state or
                federal applicable law, professional misconduct, or if any of
                the licensed personnel of Practice will fall out of good
                standing or have their licenses disciplined or revoked, or if
                there is a malpractice suit filed against the Practice or any of
                the Practice’s providers related to any patients for whom
                Qualiphy provided Professional Screening Services.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <a name="bookmark=id.17dp8vu" />
            <font face="Arial, sans-serif">
              7.
              <font face="Times New Roman, serif">
                <u>
                  <b>Inde</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                <b>p</b>
              </font>
              <font face="Times New Roman, serif">
                <u>
                  <b>endent Contractor Status.</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                <b></b>
              </font>
              <font face="Times New Roman, serif">
                The Parties acknowledge and agree that the Parties are at all
                times independent contractors under this Agreement. Nothing in
                this Agreement will in any way be construed to constitute
                Qualiphy as an agent, employee, or representative of Practice.
                The sole function of Qualiphy under this Agreement is to provide
                Professional Screening Services through its employees and
                contractors. Qualiphy will not, by entering into this Agreement
                and performing the Professional Screening Services, become
                liable for any of the obligations or liabilities of Practice as
                it relates to practice of medicine and provision of professional
                services to patients by the Practice or any employee, agent,
                representative or independent contractor of Practice. Qualiphy
                will not have any liability whatsoever for damages suffered on
                account of the provision of services to patients by any
                employee, agent, representative or independent contractor of
                Practice. The terms of this Section 7 will survive this
                Agreement indefinitely.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              8.
              <font face="Times New Roman, serif">
                <u>
                  <b>
                    Representations and Warranties of Practice and Medical
                    Director
                  </b>
                </u>
              </font>
              <font face="Times New Roman, serif">.</font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              8.1
              <font face="Times New Roman, serif">
                Practice represents and warrants to Qualiphy at all times during
                the Term of this Agreement that:
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              (a)
              <font face="Times New Roman, serif">
                Practice will at all times have a Medical Director, and the
                Medical Director will approve all screening questionnaires used
                by Qualiphy;
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              (b)
              <font face="Times New Roman, serif">
                Practice will employ licensed providers who have the appropriate
                license, training and experience to provide all treatments in
                the Treatment Recommendations provided by Qualiphy, and that
                Practice will never carry out a Treatment Recommendation for
                which there is no appropriately licensed, trained and
                experienced provider;
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              (c)
              <font face="Times New Roman, serif">
                Practice will ensure that all providers providing treatments are
                at all times appropriately supervised as required by applicable
                state law. Practice’s Medical Director will provide or ensure
                there is another appropriately licensed physician available to
                provide direct supervision for any treatments provided by
                Practice requiring supervision and overview by a physician as
                required by state law;
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              (d)
              <font face="Times New Roman, serif">
                Practice and Medical Director will at all times comply with
                HIPAA and any applicable state privacy laws;
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              (e)
              <font face="Times New Roman, serif">
                Practice will maintain all necessary permits, filings and
                registrations with the appropriate government boards and bodies
                in the state(s) of its location and with the federal government;
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              (f)
              <font face="Times New Roman, serif">
                Practice and its owners and/or employees, as applicable, have
                obtained and will maintain all proper licenses, certifications,
                and permits required for operation as a medical practice in the
                state, county and city in which the Practice is located;
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              (g)
              <font face="Times New Roman, serif">
                Practice and its Medical Director(s) have obtained and will
                maintain all proper federal and state licenses required for
                prescribing any medications and/or drugs in any patient
                treatment plan, as applicable;
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              (h)
              <font face="Times New Roman, serif">
                Practice is in compliance with all state laws, rules and
                regulations relating to the practice of medicine, including any
                corporate practice of medicine laws, rules and regulations
                relating to its business, operations and corporate structure as
                applicable;
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              (i)
              <font face="Times New Roman, serif">
                Practice’s Medical Director will exercise complete discretion
                and independent professional judgment in the performance of
                medical treatments provided at the Practice and will supervise
                and delegate to the Practice Providers as provided in this
                Agreement;
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              (j)
              <font face="Times New Roman, serif">
                Practice is in compliance with and will continue to be in
                compliance with and obey all federal, state, and local laws,
                regulations and ordinances relating to its business and the
                professional services which Practice provides; and
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              (k)
              <font face="Times New Roman, serif">
                Practice and Medical Director will maintain proper policy and
                procedures for treatment of patients, including a plan for
                emergency response to evaluate and treat based on specific
                patient circumstance in consultation with Medical Director.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              9.
              <font face="Times New Roman, serif">
                <u>
                  <b>Qualiphy Representations and Warranties</b>
                </u>
              </font>
              <font face="Times New Roman, serif">.</font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              9.1
              <font face="Times New Roman, serif">
                Qualiphy represents and warrants to Practice at all times during
                the Term of this Agreement that:
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              (a)
              <font face="Times New Roman, serif">
                Qualiphy and its employees will at all times comply with HIPAA;
                and
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <a name="bookmark=id.3rdcrjn" />
            <font face="Arial, sans-serif">
              (b)
              <font face="Times New Roman, serif">
                Each Qualiphy provider providing Professional Screening Services
                for Practice will be actively licensed to practice with the
                Practice State during the time such provider is providing the
                Professional Screening Services for Practice and will provide
                such services within the scope of their license.{" "}
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <a name="bookmark=id.26in1rg" />
            <font face="Arial, sans-serif">
              9.2
              <font face="Times New Roman, serif">
                EXCEPT FOR THE EXPRESS WARRANTIES IN THIS AGREEMENT, QUALIPHY
                HEREBY DISCLAIMS ALL WARRANTIES, EITHER EXPRESS, IMPLIED,
                STATUTORY, OR OTHERWISE. QUALIPHY IS ONLY PROVIDING SCREENING TO
                DETERMINE MEDICAL APPROPRIATENESS OF TREATMENT. QUALIPHY MAKES
                NO GUARNATEES OR WARRANTIES EXPRESS OR IMPLIED REGARDING SUCCESS
                OF ANY TREATMENT RECOMMENDATION PROVIDED.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <a name="bookmark=id.lnxbz9" />
            <font face="Arial, sans-serif">
              10.
              <font face="Times New Roman, serif">
                <u>
                  <b>Indemnification</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                <b>.</b>
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              10.1
              <font face="Times New Roman, serif">
                Practice agrees to promptly and fully defend, indemnify and hold
                harmless Qualiphy and its owners, affiliates, providers,
                officers, directors, members, attorneys employees and agents
                against all third party claims, liabilities, demands, judgments,
                damages, losses, costs and expenses, including reasonable
                attorney’s fees, arising out of or relating to: (a) the acts or
                omissions of Practice, its owners, medical directors, employees
                and agents; or (b) Practice’s breach of any representation or
                warranty in this Agreement.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <a name="bookmark=id.35nkun2" />
            <font face="Arial, sans-serif">
              10.2
              <font face="Times New Roman, serif">
                Qualiphy agrees to promptly and fully defend, indemnify and hold
                harmless Practice and its owners, affiliates, officers, members,
                directors, attorneys employees and agents against all third
                party claims, liabilities, demands, and judgments, damages,
                losses, costs and expenses, including reasonable attorneys’
                fees, arising out of any Qualiphy provider’s gross negligence in
                screening; provided, however, Qualiphy will have no obligation
                to indemnify Practice for any claims that result primarily from
                the negligent acts or omissions of Practice or Practice’s staff
                or for any faulty information provided by Practice to Qualiphy.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              11.
              <font face="Times New Roman, serif">
                <u>
                  <b>LIMITATION OF LIABILITY</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                . THE PRACTICE ACKNOWLEDGES AND AGREES THAT THE LIMITATIONS OF
                LIABILITY SET FORTH IN THIS AGREEMENT ARE REASONABLE AND REFLECT
                A FAIR ALLOCATION OF RISK BETWEEN THE PARTIES. THE PRACTICE
                FURTHER ACKNOWLEDGES THAT QUALIPHY'S FEES FOR SERVICES ARE BASED
                UPON THESE LIMITATIONS, AND THAT THE PRACTICE HAS VOLUNTARILY
                AGREED TO THE LIMITATIONS AS A CONDITION OF RECEIVING THE
                SERVICES PROVIDED BY QUALIPHY. QUALIPHY'S TOTAL LIABILITY
                ARISING OUT OF OR RELATED TO THIS AGREEMENT FOR ANY CLAIMS OF
                ANY NATURE SHALL NOT EXCEED THE TOTAL AMOUNT OF FEES PAID BY THE
                PRACTICE TO QUALIPHY FOR SERVICES RENDERED UNDER THIS AGREEMENT
                DURING THE TWELVE (12) MONTHS IMMEDIATELY PRECEDING THE EVENT
                GIVING RISE TO THE CLAIM, EXCLUDING ANY COSTS ASSOCIATED WITH
                MEDICATION. IN NO EVENT SHALL QUALIPHY BE LIABLE FOR ANY
                CONSEQUENTIAL, SPECIAL, INDIRECT, INCIDENTAL, PUNITIVE, OR
                EXEMPLARY DAMAGES, COSTS, EXPENSES, OR LOSSES, INCLUDING BUT NOT
                LIMITED TO LOST PROFITS, LOST DATA, BUSINESS INTERRUPTION, OR
                OTHER ECONOMIC LOSS, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
                DAMAGES.
              </font>
            </font>
          </p>
          <div className="western text-justify" align="justify">
            <font face="Arial, sans-serif">
              <font face="Times New Roman, serif">
                FOR THE AVOIDANCE OF DOUBT, QUALIPHY IS NOT LIABLE FOR ANY
                TREATMENTS PROVIDED BY THE PRACTICE AND ITS PROVIDERS. PRACTICE
                AGREES TO RELEASE AND WAIVE ANY AND ALL CLAIMS FOR LIABILITY
                AGAINST QUALIPHY FOR ANY POOR OUTCOMES OF ANY PROCEDURES,
                TREATMENTS, DIAGNOSIS, MEDICATIONS OR CARE FURNISHED BY OR
                THROUGH QUALIPHY. QUALIPHY IS NOT RESPONSIBLE IN ANY WAY FOR FOR
                THE OUTCOME OF TREATMENTS.
              </font>
            </font>
          </div>
          <div
            className="western text-justify"
            align="justify"
            style={{
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.17in",
              marginBottom: "0.17in",
            }}
          >
            <font face="Arial, sans-serif">
              <font face="Times New Roman, serif">
                FURTHERMORE, QUALIPHY SHALL HAVE NO LIABILITY TO THE PRACTICE
                FOR DAMAGES RESULTING FROM: (A) AN ACT OR OMISSION BY ANY
                AUTHORIZED USER TO OR USE OF THE SERVICES OR AN AUTHORIZED
                USER'S ACCESS CREDENTIALS, THAT DOES NOT STRICTLY COMPLY WITH
                THIS AGREEMENT AND THE SPECIFICATIONS; (B) THE PRACTICE'S OR ITS
                AUTHORIZED USER'S INTERNET CONNECTIVITY; (C) FORCE MAJEURE
                EVENTS; (D) FAILURE, INTERRUPTION, OUTAGE, OR OTHER PROBLEM WITH
                ANY SOFTWARE, HARDWARE, SYSTEM, NETWORK, FACILITY, OR OTHER
                MATTER SUPPLIED BY QUALIPHY PURSUANT TO THIS AGREEMENT; (E)
                SCHEDULED OR UNSCHEDULED DOWNTIME; (F) DISABLING, SUSPENSION, OR
                TERMINATION OF THE SERVICES; (G) ANY INACCURATE DATA OR OTHER
                INFORMATION FURNISHED BY OR ON BEHALF OF THE PRACTICE; (H) ANY
                TECHNICAL FAILURES IN QUALIPHY’S INTERFACE, INCLUDING BUT NOT
                LIMITED TO ANY FAILURE, INTERRUPTION, OUTAGE, ANY LOST DATA AS A
                RESULT OF ANY TECHNOLOGICAL ERROR, OR OTHER PROBLEM WITH ANY
                SOFTWARE, HARDWARE, SYSTEM, NETWORK, OR FACILITY; (I) AN ACT OR
                OMISSION BY THE PRACTICE OR ITS PROVIDERS; (J) PATIENT
                NON-COMPLIANCE WITH PRESCRIBED TREATMENTS; (K) ERRORS IN THE
                MEDICAL HISTORY OR INFORMATION PROVIDED BY THE PRACTICE; OR (L)
                ISSUES ARISING FROM THE HANDLING, DISPENSING, OR ADMINISTRATION
                OF ANY PRESCRIBED MEDICATION BY THIRD PARTIES, INCLUDING
                PHARMACIES.
              </font>
            </font>
          </div>
          <div
            className="text-justify mt-4 mb-4"
            style={{
              textIndent: "-0in",
              marginLeft: "0in",
            }}
          >
            <span className="text-gray-800 font-serif">
              QUALIPHY'S LIABILITY IS STRICTLY LIMITED TO THE PERFORMANCE OF THE
              PROFESSIONAL SERVICES AS OUTLINED IN THIS AGREEMENT AND DOES NOT
              EXTEND TO ANY OUTCOMES, ADVERSE EFFECTS, OR LONG-TERM IMPACTS OF
              TREATMENTS OR PRESCRIPTIONS PROVIDED.
            </span>
          </div>

          <div
            className="western text-justify"
            align="justify"
            style={{
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.17in",
              marginBottom: "0.17in",
            }}
          >
            <font face="Arial, sans-serif">
              <font face="Times New Roman, serif">
                HE PRACTICE EXPLICITLY WAIVES ANY RIGHT TO RECOVER DAMAGES FROM
                QUALIPHY IN EXCESS OF THE LIMITATIONS SET FORTH HEREIN,
                INCLUDING BUT NOT LIMITED TO ANY CLAIM FOR LOST PROFITS,
                BUSINESS INTERRUPTION, OR PUNITIVE DAMAGES. THE PRACTICE AGREES
                THAT THIS WAIVER IS A MATERIAL INDUCEMENT FOR QUALIPHY TO ENTER
                INTO THIS AGREEMENT AND PROVIDE SERVICES.
              </font>
            </font>
          </div>

          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              12.
              <font face="Times New Roman, serif">
                <u>
                  <b>Nondiscrimination</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                . Neither the Practice nor Qualiphy (or any provider provided by
                Practice or Qualiphy) will differentiate or discriminate in the
                providing of services on the basis of race, color, national
                origin, ancestry, religion, sex, marital status, sexual
                orientation, age, medical condition, medical history, genetics,
                evidence of insurability, or claims history, in violation of any
                applicable state, federal or local law or regulation, including,
                without limitation, the Age Discrimination Act of 1975, the
                Americans with Disabilities Act and all regulations issued
                pursuant thereto and as may be amended from time to time.{" "}
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{ orphans: 2, widows: 2, textIndent: "-0in" }}
          >
            <font face="Arial, sans-serif">
              13.
              <font face="Times New Roman, serif">
                <u>
                  <b>Confidential Information.</b>
                </u>
              </font>
              <font face="Times New Roman, serif"> </font>
            </font>
          </p>
          <div
            className="western text-justify"
            align="justify"
            style={{
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.17in",
              lineHeight: 1,
              marginBottom: "0.17in",
            }}
          >
            <font face="Arial, sans-serif">
              13.1
              <font face="Times New Roman, serif">
                <b>Confidential Information.</b>
              </font>
              <font face="Times New Roman, serif">
                {" "}
                All non-public, confidential, or proprietary information of
                either party ("Confidential Information"), including but not
                limited to information about medical providers, exam questions,
                technology built, templated exams, business affairs, products,
                services, methodologies, intellectual property, trade secrets,
                third-party confidential information, and other sensitive or
                proprietary information, disclosed by one party (the "Disclosing
                Party") to the other party (the "Receiving Party"), whether
                disclosed orally or in written, electronic, or other forms or
                media, or otherwise learned by the Receiving Party in connection
                with this Agreement, is confidential. This Confidential
                Information is solely for use in performing this Agreement and
                may not be disclosed or copied unless authorized by the
                Disclosing Party in writing. The Receiving Party shall protect
                and safeguard the confidentiality of the Disclosing Party's
                Confidential Information with at least the same degree of care
                as it would protect its own Confidential Information, but in no
                event with less than a commercially reasonable degree of care.
              </font>
            </font>
          </div>
          <div
            className="text-justify mt-4 mb-4"
            style={{
              textIndent: "-0in",
              marginLeft: "0in",
            }}
          >
            <div>
              Confidential Information does not include any information that:
              <span className="font-sans">(a)</span> is or becomes generally
              available to the public other than as a result of the Receiving
              Party's breach of this Agreement;
              <span className="font-sans">(b)</span> is obtained by the
              Receiving Party on a non-confidential basis from a third party
              that was not legally or contractually restricted from disclosing
              such information;
              <span className="font-sans">(c)</span> the Receiving Party can
              establish by documentary evidence was in its possession prior to
              the Disclosing Party's disclosure;
              <span className="font-sans">(d)</span> was or is independently
              developed by the Receiving Party without using any of the
              Disclosing Party's Confidential Information; or
              <span className="font-sans">(e)</span> is required to be disclosed
              under applicable law, regulation, or a valid court order.
            </div>
          </div>

          <div
            className="western text-justify"
            align="justify"
            style={{
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.17in",
              marginBottom: "0.17in",
            }}
          >
            <font face="Arial, sans-serif">
              <font face="Times New Roman, serif">
                The Receiving Party shall be responsible for any breach of this
                Section caused by its employees, contractors, agents, or
                representatives. Upon the expiration or termination of the
                Agreement, at the Disclosing Party's written request, the
                Receiving Party shall promptly return or destroy all copies of
                the Disclosing Party's Confidential Information and certify in
                writing that such information has been destroyed. Each party's
                obligations under this Section will survive the termination or
                expiration of this Agreement for a period of 24 months, except
                for Confidential Information that constitutes a trade secret,
                which shall remain protected for as long as it remains a trade
                secret.
              </font>
            </font>
          </div>
          <div
            className="western text-justify"
            align="justify"
            style={{
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.17in",
              marginBottom: "0.17in",
            }}
          >
            <font face="Arial, sans-serif">
              13.2
              <font face="Times New Roman, serif">
                <b>Non-Replication.</b>
              </font>
              <font face="Times New Roman, serif">
                {" "}
                The Practice agrees that it shall not replicate, reverse
                engineer, or copy Qualiphy’s technology, business model,
                workflows, or service offerings. The Practice further agrees
                that it shall not share, disclose, or provide access to any
                information about Qualiphy’s technology, business model,
                workflows, or service offerings to any third party, including
                competitors or potential competitors of Qualiphy.
              </font>
            </font>
          </div>
          <div
            className="western text-justify"
            align="justify"
            style={{
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.17in",
              marginBottom: "0.17in",
            }}
          >
            <font face="Arial, sans-serif">
              13.3
              <font face="Times New Roman, serif">
                <b>Non-Solicitation.</b>
              </font>
              <font face="Times New Roman, serif">
                {" "}
                The Practice agrees that it shall not, directly or indirectly,
                solicit, contact, or attempt to solicit or contact any clients,
                customers, or providers of Qualiphy for the purpose of offering
                services that are similar to or competitive with those provided
                by Qualiphy. The Practice also agrees not to induce or attempt
                to induce any clients, customers, or providers of Qualiphy to
                terminate their relationship with Qualiphy. Additionally, the
                Practice agrees not to solicit, recruit, or attempt to solicit
                or recruit any employee, independent contractor, or agent of
                Qualiphy for employment or engagement with the Practice or any
                third party. The Practice agrees not to induce or attempt to
                induce any employee, independent contractor, or agent of
                Qualiphy to terminate their employment or engagement with
                Qualiphy or to divulge any confidential or proprietary
                information related to Qualiphy’s business, clients, or
                technology.
              </font>
            </font>
          </div>
          <div
            className="western text-justify"
            align="justify"
            style={{
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.17in",
              marginBottom: "0.17in",
            }}
          >
            <font face="Arial, sans-serif">
              13.4
              <font face="Times New Roman, serif">
                <b>Confidentiality of Client Information.</b>
              </font>
              <font face="Times New Roman, serif">
                The Practice agrees that it shall not, during the term of this
                Agreement and at any time thereafter, disclose, share, or use
                for any purpose other than the performance of its obligations
                under this Agreement any confidential or proprietary information
                related to Qualiphy’s clients, customers, or providers. The
                Practice shall take all necessary precautions to protect the
                confidentiality of such information and shall immediately notify
                Qualiphy of any unauthorized use or disclosure.
              </font>
            </font>
          </div>
          <div
            className="western text-justify"
            align="justify"
            style={{
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.17in",
              marginBottom: "0.17in",
            }}
          >
            <font face="Arial, sans-serif">
              13.5
              <font face="Times New Roman, serif">
                <b>Damages and Remedies.</b>
              </font>
              <font face="Times New Roman, serif">
                In the event of a breach of this section by the Practice,
                Qualiphy shall be entitled to seek all available legal and
                equitable remedies, including but not limited to injunctive
                relief, specific performance, and monetary damages. The Practice
                acknowledges that any breach of this section may cause
                irreparable harm to Qualiphy for which monetary damages may be
                inadequate and agrees that Qualiphy shall be entitled to seek
                injunctive relief without the necessity of posting a bond.
                Additionally, the Practice agrees to pay Qualiphy liquidated
                damages in the amount of $50,000 per violation, which the
                Parties agree represents a reasonable estimate of the damages
                that would result from such a breach. This remedy shall be in
                addition to any other remedies available under this Agreement,
                at law, or in equity.
              </font>
            </font>
          </div>
          <div
            className="western text-justify"
            align="justify"
            style={{
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.17in",
              marginBottom: "0.17in",
            }}
          >
            <a name="bookmark=id.z337ya" />
            <font face="Arial, sans-serif">
              13.6
              <font face="Times New Roman, serif">
                <b>Restriction on Soliciting Employees.</b>
              </font>
              <font face="Times New Roman, serif">
                In consideration of Qualiphy providing Confidential Information
                to the Practice in connection with this Agreement, the Practice
                covenants that during the Term and for a period of 24 months
                immediately following the expiration or termination of this
                Agreement, the Practice will not, directly or indirectly: (a)
                solicit or attempt to solicit any of the employees or
                independent contractors of Qualiphy, either for the Practice’s
                own account or on behalf of any other entity; (b) induce or
                attempt to induce any employee or independent contractor of
                Qualiphy to leave their employment or engagement with Qualiphy;
                or (c) employ or engage any such person within 12 months of
                their termination of employment or engagement with Qualiphy
              </font>
            </font>
          </div>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              14.
              <font face="Times New Roman, serif">
                <u>
                  <b>Dispute Resolution.</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                {" "}
                In the event that any disagreement, dispute, or claim arises
                among the Parties hereto with respect to the enforcement or
                interpretation of this Agreement or any specific terms and
                provisions hereof or with respect to whether an alleged breach
                or default hereof has or has not occurred (collectively, a “
              </font>
              <font face="Times New Roman, serif">
                <b>Dispute</b>
              </font>
              <font face="Times New Roman, serif">
                ”), such Dispute shall be settled in accordance with the
                following procedures:
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              14.1
              <font face="Times New Roman, serif">
                <u>
                  <b>Meet and Confer</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                . In the event of a Dispute among the Parties hereto, a Party
                may give written notice to all other Parties setting forth the
                nature of such Dispute (the “
              </font>
              <font face="Times New Roman, serif">
                <b>Dispute Notice</b>
              </font>
              <font face="Times New Roman, serif">
                ”). The Parties shall meet and confer to discuss the Dispute in
                good faith within ten (10) days following the other Parties’
                receipt of the Dispute Notice in an attempt to resolve the
                Dispute. All representatives shall meet at such date(s) and
                time(s) as are mutually convenient to the representatives of
                each participant within the “Meet and Confer Period” (as defined
                herein below).
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              14.2
              <font face="Times New Roman, serif">
                <u>
                  <b>Mediation</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                . If the Parties are unable to resolve the Dispute within thirty
                (30) days following the date of receipt of the Dispute Notice by
                the other Parties (the “
              </font>
              <font face="Times New Roman, serif">
                <b>Meet and Confer Period</b>
              </font>
              <font face="Times New Roman, serif">
                ”), then the Parties shall attempt in good faith to settle the
                Dispute through nonbinding mediation under the Rules of Practice
                and Procedures (the “
              </font>
              <font face="Times New Roman, serif">
                <b>Rules</b>
              </font>
              <font face="Times New Roman, serif">”) of JAMS, Inc. (“</font>
              <font face="Times New Roman, serif">
                <b>JAMS</b>
              </font>
              <font face="Times New Roman, serif">
                ”) or such other neutral service as the Parties may agree. A
                single disinterested third party mediator located in Los Angeles
                County, California shall be selected by JAMS in accordance with
                its then current Rules. The parties to the Dispute shall share
                the expenses of the mediator and the other costs of mediation on
                a pro rata basis.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              14.3
              <font face="Times New Roman, serif">
                <u>
                  <b>Arbitration</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                . Any Dispute which cannot be resolved by the Parties within
                sixty (60) days following the end of the Meet and Confer Period
                shall be resolved by final and binding arbitration (the “
              </font>
              <font face="Times New Roman, serif">
                <b>Arbitration</b>
              </font>
              <font face="Times New Roman, serif">
                ”). The Arbitration shall be initiated and administered by and
                in accordance with the then current Rules of JAMS. The
                Arbitration shall be held before a single disinterested
                third-party arbitrator selected in accordance with the then
                current Rules of JAMS, in Los Angeles County, unless the parties
                mutually agree to have such proceeding in some other locale; the
                exact time and location shall be decided by the arbitrator in
                accordance with the then current Rules of JAMS. The arbitrator
                shall apply California substantive law, or federal substantive
                law where state law is preempted. The arbitrator selected shall
                have the power to enforce the rights, remedies, duties,
                liabilities, and obligations of discovery by the imposition of
                the same terms, conditions, and penalties as can be imposed in
                like circumstances in a civil action by a court of competent
                jurisdiction of the State of California. The arbitrator shall
                have the power to grant all legal and equitable remedies
                provided by California law and award compensatory damages
                provided by California law, except that punitive damages shall
                not be awarded. The arbitrator shall prepare in writing and
                provide to the Parties an award including factual findings and
                the legal reasons on which the award is based. The arbitration
                award may be enforced through an action thereon brought in the
                Superior Court for the State of California in Los Angeles
                County. The prevailing Party in any Arbitration hereunder shall
                be awarded reasonable attorneys’ fees, expert and non-expert
                witness costs and any other expenses incurred directly or
                indirectly with said Arbitration, including without limitation
                the fees and expenses of the arbitrator.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.08in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              14.4
              <font face="Times New Roman, serif">
                THIS ELECTION OF AN ALTERNATIVE DISPUTE PROCESS IS AN
                AFFIRMATIVE WAIVER OF THE PARTIES’ RIGHTS TO A JURY TRIAL UNDER
                CALIFORNIA LAW. BY SIGNING BELOW, EACH PARTY IS EXPLICITLY
                WAIVING JURY TRIAL AND AUTHORIZING ANY AND ALL PARTIES TO FILE
                THIS WAIVER WITH ANY COURT AS THE WAIVER REQUIRED UNDER
                CALIFORNIA LAW.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <a name="bookmark=id.3j2qqm3" />
            <font face="Arial, sans-serif">
              15.
              <font face="Times New Roman, serif">
                <u>
                  <b>Miscellaneous</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                <b>.</b>
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            style={{
              marginLeft: "0in",
              marginTop: "0.17in",
              marginBottom: "0.17in",
            }}
          >
            <font face="Arial, sans-serif">
              <font face="Times New Roman, serif">
                <b>API Access and Documentation</b>
              </font>
            </font>
          </p>
          <div
            className="western text-justify"
            style={{
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.17in",
              marginBottom: "0.17in",
            }}
          >
            <font face="Arial, sans-serif">
              <font face="Times New Roman, serif">
                <b>Grant of API Access.</b>
              </font>
              <font face="Times New Roman, serif">
                Qualiphy PC ("Qualiphy") hereby grants a non-exclusive,
                revocable, limited license to access and use Qualiphy’s
                Application Programming Interface (“API”) and associated
                documentation solely for the purpose of integrating Qualiphy’s
                services into Practices systems in accordance with the terms of
                this Agreement. This access is provided to facilitate the
                delivery of services as defined under this Agreement and shall
                be used exclusively to support the operations and
                functionalities specified herein.
              </font>
            </font>
          </div>
          <div
            className="western text-justify"
            style={{
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.17in",
              marginBottom: "0.17in",
            }}
          >
            <font face="Arial, sans-serif">
              <font face="Times New Roman, serif">
                <b>Usage Restrictions.</b>
              </font>
              <font face="Times New Roman, serif">
                {" "}
                Practice agrees to use the API and associated documentation in
                strict accordance with the terms of this Agreement. The
                following restrictions apply:
              </font>
            </font>
          </div>
          <ol>
            <li>
              <div
                className="western text-justify"
                style={{
                  orphans: 2,
                  widows: 2,
                  textIndent: "0in",
                  marginTop: "0.17in",
                }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    <b>Authorized Use Only:</b>
                  </font>
                  <font face="Times New Roman, serif">
                    {" "}
                    Practice shall use the API only for the purposes expressly
                    permitted by this Agreement and in compliance with all
                    applicable laws and regulations. Any use of the API beyond
                    what is permitted under this Agreement is strictly
                    prohibited.
                  </font>
                </font>
              </div>
            </li>
            <li>
              <div
                className="western text-justify"
                style={{ orphans: 2, widows: 2, textIndent: "0in" }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    <b>No Reverse Engineering:</b>
                  </font>
                  <font face="Times New Roman, serif">
                    Practice shall not, and shall not permit any third party to,
                    modify, reverse engineer, decompile, or disassemble the API
                    or any software or code related to the API, nor create
                    derivative works based on the API or its documentation.
                  </font>
                </font>
              </div>
            </li>
            <li>
              <div
                className="western text-justify"
                style={{ orphans: 2, widows: 2, textIndent: "0in" }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    <b>No Unauthorized Access:</b>
                  </font>
                  <font face="Times New Roman, serif">
                    Practice shall not use the API to gain unauthorized access
                    to any systems, data, or networks, and shall not permit any
                    unauthorized third party to access the API. Practice must
                    ensure that access to the API is restricted to only those
                    individuals or systems necessary to perform the functions
                    under this Agreement.
                  </font>
                </font>
              </div>
            </li>
            <li>
              <div
                className="western text-justify"
                style={{ orphans: 2, widows: 2, textIndent: "0in" }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    <b>Data Privacy and Security:</b>
                  </font>
                  <font face="Times New Roman, serif">
                    Practice agrees to implement and maintain robust data
                    privacy and security measures to protect the API and any
                    data transmitted through the API from unauthorized access,
                    use, or disclosure. Practice is responsible for any breach
                    of data privacy or security resulting from misuse or abuse
                    of the API.
                  </font>
                </font>
              </div>
            </li>
            <li>
              <div
                className="western text-justify"
                style={{ orphans: 2, widows: 2, textIndent: "0in" }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    <b>Rate Limits and Usage Monitoring:</b>
                  </font>
                  <font face="Times New Roman, serif">
                    Qualiphy reserves the right to impose rate limits on API
                    usage and to monitor usage to ensure compliance with this
                    Agreement. Practice agrees not to exceed any rate limits
                    imposed by Qualiphy and acknowledges that exceeding such
                    limits may result in suspension or termination of API
                    access.
                  </font>
                </font>
              </div>
            </li>
            <li>
              <div
                className="western text-justify"
                style={{ orphans: 2, widows: 2, textIndent: "0in" }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    <b>Reporting and Notifications:</b>
                  </font>
                  <font face="Times New Roman, serif">
                    Practice shall immediately notify Qualiphy in writing if it
                    becomes aware of any misuse, abuse, or unauthorized use of
                    the API. Practice agrees to cooperate fully with Qualiphy in
                    investigating and addressing any such misuse or abuse.
                  </font>
                </font>
              </div>
            </li>
            <li>
              <div
                className="western text-justify"
                style={{ orphans: 2, widows: 2, textIndent: "0in" }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    <b>Termination of API Access:</b>
                  </font>
                  <font face="Times New Roman, serif">
                    Qualiphy reserves the right to terminate or suspend API
                    access at any time, with or without cause, upon written
                    notice to Practice. Upon termination or expiration of this
                    Agreement, Practice access to the API shall immediately
                    cease, and Practice shall delete any API keys or access
                    credentials provided by Qualiphy.
                  </font>
                </font>
              </div>
            </li>
            <li>
              <div className="western text-justify">
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    <b>Indemnification for Misuse:</b>
                  </font>
                  <font face="Times New Roman, serif">
                    {" "}
                    Practice agrees to indemnify, defend, and hold harmless
                    Qualiphy and its affiliates from and against any and all
                    claims, damages, liabilities, costs, and expenses (including
                    reasonable attorneys’ fees) arising out of or related to
                    Practice misuse or abuse of the API, or any breach of this
                    Section.{" "}
                  </font>
                </font>
              </div>
            </li>
          </ol>
          <p
            className="western text-justify"
            style={{
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginTop: "0.17in",
              marginBottom: "0.17in",
            }}
          >
            <br />
            <br />
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <a name="bookmark=id.1y810tw" />
            <font face="Arial, sans-serif">
              15.1
              <font face="Times New Roman, serif">
                <u>
                  <b>No Publicity</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                <b>.</b>
              </font>
              <font face="Times New Roman, serif">
                Neither party shall issue or release any announcement,
                statement, press release, or other publicity or marketing
                materials relating to this Agreement, or otherwise use the other
                party’s trademarks, service marks, trade names, logos, symbols,
                or brand names, in each case, without the prior written consent
                of the other party.{" "}
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <a name="bookmark=id.4i7ojhp" />
            <font face="Arial, sans-serif">
              15.2
              <font face="Times New Roman, serif">
                <u>
                  <b>Notice</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                <b>.</b>
              </font>
              <font face="Times New Roman, serif">
                All notices, requests, consents, claims, demands, waivers, and
                other communications hereunder (each, a “
              </font>
              <font face="Times New Roman, serif">
                <b>Notice</b>
              </font>
              <font face="Times New Roman, serif">
                ”) shall be in writing and addressed to the parties at the
                addresses set forth on the first page of this Agreement (or to
                such other address that may be designated by the receiving party
                from time to time in accordance with this Section). All Notices
                shall be delivered by personal delivery, nationally recognized
                overnight courier (with all fees pre-paid), facsimile or email
                (with confirmation of transmission) or certified or registered
                mail (in each case, return receipt requested, postage pre-paid).
                Except as otherwise provided in this Agreement, a Notice is
                effective only (a) upon receipt by the receiving party; and (b)
                if the party giving the Notice has complied with the
                requirements of this Section.{" "}
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <a name="bookmark=id.2xcytpi" />
            <font face="Arial, sans-serif">
              15.3
              <font face="Times New Roman, serif">
                <u>
                  <b>Entire Agreement; Order of Precedence</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                . This Agreement, together with all Schedules and Exhibits and
                any other documents incorporated herein by reference,
                constitutes the sole and entire agreement of the parties to this
                Agreement with respect to the subject matter contained herein,
                and supersedes all prior and contemporaneous understandings and
                agreements, both written and oral, with respect to such subject
                matter. In the event of any conflict between the terms and
                provisions of this Agreement and those of any Schedule or
                Exhibit, then the terms of this Agreement shall control unless
                expressly set forth otherwise in the applicable Schedule or
                Exhibit.{" "}
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <a name="bookmark=id.1ci93xb" />
            <font face="Arial, sans-serif">
              15.4
              <font face="Times New Roman, serif">
                <u>
                  <b>Assignment</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                . Practice may not assign, transfer, or delegate any or all of
                its rights or obligations under this Agreement, including by
                operation of law, change of control, or merger, without the
                prior written consent of Qualiphy, which consent shall not be
                unreasonably withheld or delayed. Qualiphy may only assign this
                Agreement to any of its wholly owned affiliates or successors of
                its business. This Agreement shall be binding upon and shall
                inure to the benefit of the parties hereto and their respective
                successors and permitted assigns.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <a name="bookmark=id.3whwml4" />
            <font face="Arial, sans-serif">
              15.5
              <font face="Times New Roman, serif">
                <u>
                  <b>No Third-Party Beneficiaries</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                . This Agreement is for the sole benefit of the parties hereto
                and their respective successors and permitted assigns and
                nothing herein, express or implied, is intended to or shall
                confer upon any other Person any legal or equitable right,
                benefit, or remedy of any nature whatsoever, under or by reason
                of this Agreement.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              15.6
              <font face="Times New Roman, serif">
                <u>
                  <b>Amendment and Modification; Waiver</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                . This Agreement may be amended, modified, or supplemented only
                by an agreement in writing signed by each party hereto. No
                failure to exercise any rights, remedy, power or privilege (
              </font>
              <font face="Times New Roman, serif">
                <b>“Right(s)”</b>
              </font>
              <font face="Times New Roman, serif">
                ) arising from this Agreement shall operate or be construed as a
                waiver thereof. No single or partial exercise of any Right
                hereunder precludes any other or further exercise thereof or the
                exercise of any other Right.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <a name="bookmark=id.2bn6wsx" />
            <font face="Arial, sans-serif">
              15.7
              <font face="Times New Roman, serif">
                <u>
                  <b>Governmental Requirements</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                <b>.</b>
              </font>
              <font face="Times New Roman, serif">
                This Agreement is subject to the requirements of all applicable
                laws and regulations. The Parties agree to negotiate in good
                faith to amend this Agreement to comply with any governmental
                requirements affecting the Agreement, including without
                limitation, requirements affecting reimbursement for health care
                services. If the Parties are unable to negotiate a mutually
                acceptable amendment to comply with any provision of law,
                regulation, or ruling materially affecting this Agreement,
                either Party may initiate a voluntary termination of this
                Agreement on 30 days’ notice.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <a name="bookmark=id.qsh70q" />
            <font face="Arial, sans-serif">
              15.8
              <font face="Times New Roman, serif">
                <u>
                  <b>Severability</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                . No invalidity, illegality, or unenforceability of any
                provision herein in any jurisdiction, shall affect any other
                term or provision of this Agreement or invalidate or render such
                provision unenforceable in any other jurisdiction. If any
                provision is determined to be invalid, illegal, or
                unenforceable, the parties hereto shall negotiate in good faith
                to modify this Agreement so as to effect the original intent of
                the parties as closely as possible.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              15.9
              <font face="Times New Roman, serif">
                <u>
                  <b>Governing Law</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                . This Agreement shall be governed by and construed in
                accordance with the internal laws of the State of California
                without giving effect to any choice or conflict of law provision
                or rule that would cause the application of laws of any other
                jurisdiction.{" "}
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              15.10
              <font face="Times New Roman, serif">
                <u>
                  <b>Force Majeure</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                . Neither Party will be liable nor deemed to be in default for
                any delay, interruption or failure in performance under this
                Agreement caused by or resulting, directly or indirectly, from
                acts of God, civil or military authority, war, terrorism,
                vandalism, riots, civil disturbances, accidents, fires,
                explosions, earthquakes, floods, failure of transportation
                infrastructure, disruption of public utilities, supply chain
                interruptions, breakdown of machinery, strike or other work
                interruptions by either Party’s employees, or any similar cause
                beyond the reasonably control of either party. However, both
                Parties will make good faith efforts to perform under this
                Agreement in the event of any such circumstances.{" "}
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <a name="bookmark=id.3as4poj" />
            <font face="Arial, sans-serif">
              15.11
              <font face="Times New Roman, serif">
                <u>
                  <b>Advice of Counsel</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                . The Parties have each been advised to seek independent legal
                counsel in entering into this Agreement and the transactions
                described herein. In the event a Party chooses not to seek
                independent legal counsel, that party does so freely and
                knowingly and waives any such rights to counsel.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              15.12
              <font face="Times New Roman, serif">
                <u>
                  <b>Equitable Relief; Cumulative Remedies</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                . Each party acknowledges that a breach Confidentiality or with
                respect to Qualiphy, Non-Solicitation, may cause the
                non-breaching party irreparable damages, for which an award of
                damages would not be adequate compensation. In the event of such
                breach or threatened breach, the non-breaching party will be
                entitled to seek equitable relief. Except as expressly set forth
                in this Agreement, the right and remedies under this Agreement
                are cumulative and in addition to any other rights or remedies
                available at law or in equity or otherwise.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              15.13
              <font face="Times New Roman, serif">
                <u>
                  <b>Counterparts</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                . This Agreement may be executed in counterparts by digital
                signature and delivered by electronic mediums including email
                and facsimile, each of which shall be deemed an original, but
                all of which together shall constitute one and the same
                instrument. Counterparts may be delivered via facsimile,
                electronic mail including pdf or any electronic signature
                complying with the U.S. federal ESIGN Act of 2000, or other
                transmission method and any counterpart so delivered shall be
                deemed to have been duly and validly delivered and be valid and
                effective for all purposes.
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              15.14
              <font face="Times New Roman, serif">
                <u>
                  <b>Authority to Sign</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                . Practice represents and warrants that the individual signing
                on behalf of the Practice is duly authorized to sign this
                Agreement on behalf of the Practice, and the Medical Director
                has reviewed and approved this Agreement.{" "}
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="center"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              <span style={{ fontVariant: "small-caps" }}>
                <font face="Times New Roman, serif">
                  [SIGNATURE PAGE FOLLOWS]
                </font>
              </span>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 2,
              widows: 2,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
              pageBreakBefore: "always",
            }}
          >
            <font face="Arial, sans-serif">
              <font face="Times New Roman, serif">
                IN WITNESS WHEREOF, the parties hereto have executed this
                Agreement as of the date when fully signed by all parties below.
              </font>
            </font>
          </p>
          <GFEForm
            signImage={signImage}
            data={data}
            isFirstSign={true}
            filledSignatureIds={filledSignatureIds}
            setFilledSignatureIds={setFilledSignatureIds}
          />
          <div className="flex flex-col items-center mt-8 mb-8">
            <p className="text-center  text-md font-bold uppercase mb-5">
              EXHIBIT A
            </p>
            <p className="text-center  text-md font-bold uppercase mb-5 break-words">
              FEES AND CREDIT CARD AUTHORIZATION
            </p>
          </div>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 0,
              widows: 0,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              <font face="Times New Roman, serif">
                <font size={2} style={{ fontSize: "11pt" }}>
                  Practice has the freedom to choose when to use Qualiphy’s
                  Professional Screening Services within hours of operation.
                  Once the Practice’s account is established with Qualiphy,
                  Practice will be given a private waiting room code and may
                  start adding patients.{" "}
                </font>
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 0,
              widows: 0,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              <font face="Times New Roman, serif">
                <font size={2} style={{ fontSize: "11pt" }}>
                  <b>
                    Qualiphy will charge $27.99 per exam completed, however if
                    an exam has different price, that price will be clearly
                    defined and stated within the portal (i.e exams with lab
                    review are $37.99 and clearly indicates price). Currently,
                    there are no sign-up fees or monthly fees associated with
                    the service. However, please note that the pricing for per
                    exam screening is subject to change. Qualiphy reserves the
                    right to modify the pricing with a 30-day prior notice to
                    Practice. In addition, Qualiphy has the option to introduce
                    subscription pricing for the service. Qualiphy can introduce
                    new exams with a different pricing model. If Qualiphy
                    decides to implement a subscription model, it will provide a
                    30-day prior notice to Practice regarding the introduction
                    and details of the subscription pricing.&nbsp;
                  </b>
                </font>
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 0,
              widows: 0,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              <font face="Times New Roman, serif">
                <font size={2} style={{ fontSize: "11pt" }}>
                  <b>
                    At the conclusion of a patient screening, Qualiphy will
                    charge the per patient screening fee to the Practice’s
                    credit card on file. This credit card will also be used for
                    any future subscription payments after a 30 day notice of
                    monthly subscription fees.{" "}
                  </b>
                </font>
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 0,
              widows: 0,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              <font face="Times New Roman, serif">
                <font size={2} style={{ fontSize: "11pt" }}>
                  Please complete all fields below. This authorization will
                  remain in effect until canceled. Practice may cancel this
                  authorization at any time by contacting Qualiphy; however, no
                  screening services will be provided unless a valid credit card
                  is on file.{" "}
                </font>
              </font>
            </font>
          </p>

          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 0,
              widows: 0,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              <font face="Times New Roman, serif">
                <font size={2} style={{ fontSize: "11pt" }}>
                  By signing below, I, as an authorized representative of the
                  Practice named above, hereby authorize Qualiphy PC
                  (“Qualiphy”) to charge the credit card provided in portal
                  according to the terms and conditions of the Qualiphy Services
                  Agreement after each patient screening provided. I understand
                  that I will not receive additional advanced notice of the
                  charges. I understand that this authorization will remain in
                  effect until I terminate it in writing and will be saved on
                  file for future transactions on the Practice account. I agree
                  to notify Qualiphy in writing of any changes to my account
                  information.
                </font>
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 0,
              widows: 0,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              <font face="Times New Roman, serif">
                <font size={2} style={{ fontSize: "11pt" }}>
                  I certify that I am an authorized representative of the
                  payment method I have provided on file, and that I will not
                  dispute the scheduled payments with my credit card company or
                  bank, as applicable, provided the transactions correspond to
                  the terms indicated in this authorization form and the
                  Services Agreement. I agree to reimburse Qualiphy its
                  out-of-pocket costs, for any chargebacks I request.{" "}
                </font>
              </font>
            </font>
          </p>

          <div className="mt-0 ml-[0.1pt] -indent-[0.1pt] text-justify leading-normal align-top w-full md:w-1/2">
            <div id={"signature2"}>
              <label className="block text-sm font-medium text-gray-700">
                Cardholder Signature:
              </label>
              {signImage && filledSignatureIds.includes("signature_2") ? (
                <SignatureComponent
                  allButtonIds={[
                    "signature_1",
                    "signature_2",
                    "signature_3",
                    "submit",
                  ]}
                  handleOnSignatureClick={handleOnSignatureClick}
                  loading={loading}
                  removeSignatures={removeSignature}
                  userSignauter={signImage}
                  id={"signature_2"}
                />
              ) : null}
              {!signImage || !filledSignatureIds.includes("signature_2") ? (
                <CustomButton
                  className="px-4"
                  labelColor="black"
                  label="Sign"
                  id={"signature_2"}
                  onClick={() =>
                    handleOnSignatureClick({ type: "adminPracticeSign" })
                  }
                />
              ) : (
                <></>
              )}
              {
                adminFormErrors?.signature_2 && (
                  <span className="text-red-500 text-sm error-message">
                    {adminFormErrors?.signature_2}
                  </span>
                ) // Optional: Display error message if signature is empty
              }
            </div>
          </div>
          <div className="mt-0 ml-[0.1pt] -indent-[0.1pt] text-justify leading-normal align-top w-full md:w-1/2">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Date:
              </label>
              <input
                disabled
                value={currentDate}
                defaultValue={currentDate}
                onChange={handleChange}
                name={"cardHolderDate"}
                type="text"
                className="border border-gray-300 rounded p-2 w-full"
              />
            </div>
          </div>
          <p
            className="western text-justify"
            align="center"
            style={{
              lineHeight: "100%",
              orphans: 0,
              widows: 0,
              textIndent: "-0in",
              marginLeft: "0in",
              marginRight: "0.01in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              <font face="Times New Roman, serif">
                <u>
                  <b>EXHIBIT B</b>
                </u>
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="center"
            style={{
              lineHeight: "100%",
              orphans: 0,
              widows: 0,
              textIndent: "-0in",
              marginLeft: "0in",
              marginRight: "0.01in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              <font face="Times New Roman, serif">
                <u>
                  <b>BUSINESS ASSOCIATE ADDENDUM</b>
                </u>
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 0,
              widows: 0,
              textIndent: "-0in",
              marginLeft: "0in",
              marginRight: "0.01in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              <font face="Times New Roman, serif">
                THIS BUSINESS ASSOCIATE AGREEMENT (hereinafter, the “
              </font>
              <font face="Times New Roman, serif">
                <u>
                  <b>BAA</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                ”) entered into and effective as of the date signed by both
                parties, is by and between Qualiphy PC, a California
                professional medical corporation (“
              </font>
              <font face="Times New Roman, serif">
                <u>
                  <b>Business Associate</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                ”) and the medical practice named on the signature page below (“
              </font>
              <font face="Times New Roman, serif">
                <u>
                  <b>Covered Entity</b>
                </u>
              </font>
              <font face="Times New Roman, serif">”).</font>
            </font>
          </p>
          <ol>
            <ol>
              <li>
                <h2
                  className="western text-justify"
                  align="center"
                  style={{
                    textIndent: "0in",
                    marginRight: "0.01in",
                    marginTop: "0in",
                    marginBottom: "0.17in",
                  }}
                >
                  <font face="Times New Roman, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <u>RECITALS:</u>
                    </font>
                  </font>
                </h2>
              </li>
            </ol>
          </ol>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 0,
              widows: 0,
              textIndent: "-0in",
              marginLeft: "0in",
              marginRight: "0.01in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              <font face="Times New Roman, serif">
                <b>WHEREAS,</b>
              </font>
              <font face="Times New Roman, serif">
                Business Associate and Covered Entity are parties to that
                certain Services Agreement, of even date herewith (as amended,
                supplemented or restated from time to time, the “
              </font>
              <font face="Times New Roman, serif">
                <u>
                  <b>Services Agreement</b>
                </u>
              </font>
              <font face="Times New Roman, serif">,”)</font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 0,
              widows: 0,
              textIndent: "-0in",
              marginLeft: "0in",
              marginRight: "0.01in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              <font face="Times New Roman, serif">
                As part of the Services Agreement, Business Associate performs
                or assists in performing a function or activity on behalf of
                Covered Entity that involves the use and/or disclosure of
                Protected Health Information; and
              </font>
            </font>
          </p>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 0,
              widows: 0,
              textIndent: "-0in",
              marginLeft: "0in",
              marginRight: "0.01in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              <font face="Times New Roman, serif">
                <b>WHEREAS</b>
              </font>
              <font face="Times New Roman, serif">
                , Business Associate and Covered Entity desire to enter into
                this BAA in order to comply with the national standards for the
                privacy of individually identifiable Protected Health
                Information adopted by the Department of Health and Human
                Services (“
              </font>
              <font face="Times New Roman, serif">
                <u>
                  <b>DHHS</b>
                </u>
              </font>
              <font face="Times New Roman, serif">
                ”) pursuant to the Health Insurance Portability and
                Accountability Act of 1996, as published in a final rule dated
                December 28, 2000, and final rule modifications published
                January 25, 2013 (as may be now or hereafter amended or
                modified, “
              </font>
              <font face="Times New Roman, serif">
                <u>
                  <b>HIPAA</b>
                </u>
              </font>
              <font face="Times New Roman, serif">”).</font>
            </font>
          </p>
          <p
            className="western text-justify"
            style={{
              lineHeight: "100%",
              orphans: 0,
              widows: 0,
              textIndent: "-0in",
              marginLeft: "0in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              <font face="Times New Roman, serif">
                Based upon the above recitals and the mutual covenants in this
                BAA, the Parties agree as follows:
              </font>
            </font>
          </p>
          <ol>
            <li>
              <p
                className="western text-justify"
                align="justify"
                style={{
                  lineHeight: "100%",
                  orphans: 0,
                  widows: 0,
                  textIndent: "0in",
                  marginRight: "0.01in",
                  border: "none",
                  padding: "0in",
                }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    <u>
                      <b>Definitions.</b>
                    </u>
                  </font>
                  <font face="Times New Roman, serif">
                    <b></b>
                  </font>
                  <font face="Times New Roman, serif">
                    For purposes of this BAA, the terms “
                  </font>
                  <font face="Times New Roman, serif">
                    <u>
                      <b>Business Associate</b>
                    </u>
                  </font>
                  <font face="Times New Roman, serif">,” “</font>
                  <font face="Times New Roman, serif">
                    <u>
                      <b>Individual</b>
                    </u>
                  </font>
                  <font face="Times New Roman, serif">,” “</font>
                  <font face="Times New Roman, serif">
                    <u>
                      <b>Use</b>
                    </u>
                  </font>
                  <font face="Times New Roman, serif">,” “</font>
                  <font face="Times New Roman, serif">
                    <u>
                      <b>Disclosure</b>
                    </u>
                  </font>
                  <font face="Times New Roman, serif">,” and “</font>
                  <font face="Times New Roman, serif">
                    <u>
                      <b>Protected Health Information</b>
                    </u>
                  </font>
                  <font face="Times New Roman, serif">
                    ”, and other terms used, but not otherwise defined in this
                    BAA, shall have the respective meanings ascribed to those
                    terms in HIPAA. The term “
                  </font>
                  <font face="Times New Roman, serif">
                    <u>
                      <b>Covered Entity</b>
                    </u>
                  </font>
                  <font face="Times New Roman, serif">
                    ” shall further include any affiliate of Covered Entity, and
                    “
                  </font>
                  <font face="Times New Roman, serif">
                    <u>
                      <b>Administrative Safeguards</b>
                    </u>
                  </font>
                  <font face="Times New Roman, serif">
                    ” shall have the same meaning as the term “administrative
                    safeguards” as defined in HIPAA with the exception that it
                    shall apply to the management of the conduct of Business
                    Associate’s workforce, rather than Covered Entity’s
                    workforce, in relation to the protection of that
                    information.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                className="western text-justify"
                align="justify"
                style={{
                  lineHeight: "100%",
                  orphans: 0,
                  widows: 0,
                  textIndent: "0in",
                  marginRight: "0.01in",
                  border: "none",
                  padding: "0in",
                }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    <u>
                      <b>Parameters of Business Relationship.</b>
                    </u>
                  </font>
                  <font face="Times New Roman, serif">
                    <b></b>
                  </font>
                  <font face="Times New Roman, serif">
                    Unless and until terminated pursuant to Section 7 of this
                    BAA or superseded, this BAA shall govern all current and
                    future engagements between Business Associate and Covered
                    Entity. Business Associate will perform services and/or
                    provide goods for or on behalf of Covered Entity as set
                    forth in the Services Agreement (“
                  </font>
                  <font face="Times New Roman, serif">
                    <u>
                      <b>Services</b>
                    </u>
                  </font>
                  <font face="Times New Roman, serif">
                    ”). In performing Services for or on behalf of Covered
                    Entity, Business Associate will be provided with and have
                    access to individually identifiable Protected Health
                    Information of Covered Entity’s patients. Business Associate
                    will Use all such Protected Health Information solely in the
                    performance of Services for or on behalf of Covered Entity,
                    in accordance with the terms of this BAA, and Business
                    Associate shall limit and regulate all Uses and Disclosures
                    of all such Protected Health Information in accordance with
                    the terms of this BAA. Business Associate may Use and
                    Disclose Protected Health Information as necessary for the
                    proper management and administration of Business Associate
                    or to carry out the legal responsibilities of Business
                    Associate (collectively, “
                  </font>
                  <font face="Times New Roman, serif">
                    <u>
                      <b>Business Associate’s Operations</b>
                    </u>
                  </font>
                  <font face="Times New Roman, serif">
                    ”). Business Associate may Disclose Protected Health
                    Information as necessary for Business Associate’s Operations
                    only if:{" "}
                  </font>
                </font>
              </p>
              <ol type="a">
                <li>
                  <p
                    className="western text-justify"
                    align="justify"
                    style={{
                      lineHeight: "100%",
                      orphans: 0,
                      widows: 0,
                      textIndent: "0in",
                      marginRight: "0.01in",
                      border: "none",
                      padding: "0in",
                    }}
                  >
                    <font face="Arial, sans-serif">
                      <font face="Times New Roman, serif">
                        the Disclosure is required by law; or{" "}
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    className="western text-justify"
                    align="justify"
                    style={{
                      lineHeight: "100%",
                      orphans: 0,
                      widows: 0,
                      textIndent: "0in",
                      marginRight: "0.01in",
                      border: "none",
                      padding: "0in",
                    }}
                  >
                    <font face="Arial, sans-serif">
                      <font face="Times New Roman, serif">
                        Business Associate ensures that any person or
                        organization to whom Business Associate will Disclose
                        such Protected Health Information agrees in writing to
                        comply with the applicable provisions of HIPAA,
                        including, but not limited to, that the person or
                        organization will (1) hold such Protected Health
                        Information in confidence and Use or further Disclose it
                        only for the purpose for which Business Associate
                        Disclosed it to the person or organization as required
                        by law; and (2) notify Business Associate of any
                        instance of which the person or organization becomes
                        aware in which the confidentiality of such Protected
                        Health Information was breached.
                      </font>
                    </font>
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <p
                className="western text-justify"
                align="justify"
                style={{
                  lineHeight: "100%",
                  orphans: 0,
                  widows: 0,
                  textIndent: "0in",
                  marginRight: "0.01in",
                  border: "none",
                  padding: "0in",
                }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    <u>
                      <b>De</b>
                    </u>
                  </font>
                  <font face="Times New Roman, serif">
                    <u>-</u>
                  </font>
                  <font face="Times New Roman, serif">
                    <u>
                      <b>Identification.</b>
                    </u>
                  </font>
                  <font face="Times New Roman, serif">
                    <b></b>
                  </font>
                  <font face="Times New Roman, serif">
                    Business Associate may de-identify Protected Health
                    Information in accordance with 45 C.F.R. § 164.514(b) and
                    use or disclose (and permit others to use or disclose)
                    de-identified information on a perpetual, unrestricted
                    basis.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                className="western text-justify"
                align="justify"
                style={{
                  lineHeight: "100%",
                  orphans: 0,
                  widows: 0,
                  textIndent: "0in",
                  marginRight: "0.01in",
                  border: "none",
                  padding: "0in",
                }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    <u>
                      <b>Duties of Business Associate.</b>
                    </u>
                  </font>
                  <font face="Times New Roman, serif">
                    <b></b>
                  </font>
                  <font face="Times New Roman, serif">
                    Business Associate agrees to comply in all material respects
                    with HIPAA when Using or Disclosing Protected Health
                    Information received by Business Associate from or on behalf
                    of Covered Entity including:
                  </font>
                </font>
              </p>
              <ol type="a">
                <li>
                  <p
                    className="western text-justify"
                    align="justify"
                    style={{
                      lineHeight: "100%",
                      orphans: 0,
                      widows: 0,
                      textIndent: "0in",
                      marginRight: "0.01in",
                      border: "none",
                      padding: "0in",
                    }}
                  >
                    <font face="Arial, sans-serif">
                      <font face="Times New Roman, serif">
                        Business Associate will not Use or Disclose Protected
                        Health Information received from Covered Entity in any
                        way other than as permitted or required by this BAA.
                        Business Associate may Use or Disclose Protected Health
                        Information as otherwise required by law.
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    className="western text-justify"
                    align="justify"
                    style={{
                      lineHeight: "100%",
                      orphans: 0,
                      widows: 0,
                      textIndent: "0in",
                      marginRight: "0.01in",
                      border: "none",
                      padding: "0in",
                    }}
                  >
                    <font face="Arial, sans-serif">
                      <font face="Times New Roman, serif">
                        Business Associate will exercise appropriate safeguards
                        to prevent Use or Disclosure of Protected Health
                        Information other than as necessary for Business
                        Associate to perform its obligations pursuant to the
                        relationship described above in Section 2 of this BAA.
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    className="western text-justify"
                    align="justify"
                    style={{
                      lineHeight: "100%",
                      orphans: 0,
                      widows: 0,
                      textIndent: "0in",
                      marginRight: "0.01in",
                      border: "none",
                      padding: "0in",
                    }}
                  >
                    <font face="Arial, sans-serif">
                      <font face="Times New Roman, serif">
                        Business Associate will promptly report to Covered
                        Entity any Use or Disclosure of Protected Health
                        Information which is not permitted or required by this
                        BAA or law and take such actions available as may be
                        reasonably necessary to correct such Use or Disclosure.
                        Business Associate’s report of any such Uses or
                        Disclosures shall be to the person who executed this BAA
                        for Covered Entity, or other individual who may be
                        designated by written notice to Business Associate.
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    className="western text-justify"
                    align="justify"
                    style={{
                      lineHeight: "100%",
                      orphans: 0,
                      widows: 0,
                      textIndent: "0in",
                      marginRight: "0.01in",
                      border: "none",
                      padding: "0in",
                    }}
                  >
                    <font face="Arial, sans-serif">
                      <font face="Times New Roman, serif">
                        Business Associate will ensure that any and all
                        subcontractors or agents to whom Business Associate
                        Discloses Protected Health Information received from or
                        on behalf of Covered Entity agree, in writing, to be
                        bound by the same restrictions, conditions and duties
                        that apply to Business Associate with respect to such
                        information. Business Associate will identify all such
                        subcontractors and agents to the Covered Entity.
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    className="western text-justify"
                    align="justify"
                    style={{
                      lineHeight: "100%",
                      orphans: 0,
                      widows: 0,
                      textIndent: "0in",
                      marginRight: "0.01in",
                      border: "none",
                      padding: "0in",
                    }}
                  >
                    <font face="Arial, sans-serif">
                      <font face="Times New Roman, serif">
                        Business Associate will maintain appropriate procedures
                        by which Individuals are granted access to their
                        Protected Health Information. Such access must be
                        granted in accordance with HIPAA.
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    className="western text-justify"
                    align="justify"
                    style={{
                      lineHeight: "100%",
                      orphans: 0,
                      widows: 0,
                      textIndent: "0in",
                      marginRight: "0.01in",
                      border: "none",
                      padding: "0in",
                    }}
                  >
                    <font face="Arial, sans-serif">
                      <font face="Times New Roman, serif">
                        Business Associate will make its internal policies and
                        procedures, and its books and records relating to Uses
                        and Disclosures of Protected Health Information received
                        from Covered Entity or created or received by the
                        Business Associate on behalf of Covered Entity,
                        available to the Covered Entity or to the Secretary of
                        DHHS for purposes of determining Business Associate’s
                        and Covered Entity’s compliance with HIPAA.
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    className="western text-justify"
                    align="justify"
                    style={{
                      lineHeight: "100%",
                      orphans: 0,
                      widows: 0,
                      textIndent: "0in",
                      marginRight: "0.01in",
                      border: "none",
                      padding: "0in",
                    }}
                  >
                    <font face="Arial, sans-serif">
                      <font face="Times New Roman, serif">
                        When notified by Covered Entity, Business Associate will
                        make available Protected Health Information for
                        amendment and incorporate any amendments or corrections
                        to Protected Health Information maintained by Business
                        Associate in compliance with HIPAA.
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    className="western text-justify"
                    align="justify"
                    style={{
                      lineHeight: "100%",
                      orphans: 0,
                      widows: 0,
                      textIndent: "0in",
                      marginRight: "0.01in",
                      border: "none",
                      padding: "0in",
                    }}
                  >
                    <font face="Arial, sans-serif">
                      <font face="Times New Roman, serif">
                        Upon request from Covered Entity, Business Associate
                        will provide to Covered Entity an accounting of all
                        Business Associate’s Disclosures of Protected Health
                        Information received from or on behalf of Covered
                        Entity, except for Disclosures made to the Individual
                        who is the subject of the Protected Health Information;
                        Disclosures for treatment, payment and health care
                        operations purposes (unless such Disclosures were made
                        using an Electronic Health Record); Disclosures for
                        national security, intelligence, correctional or law
                        enforcement purposes; and Disclosures otherwise excluded
                        from the accounting requirements pursuant to 45 C.F.R.
                        §164.528. Such an accounting shall provide:
                      </font>
                    </font>
                  </p>
                  <ol type="i">
                    <li>
                      <p
                        className="western text-justify"
                        align="justify"
                        style={{
                          lineHeight: "100%",
                          orphans: 0,
                          widows: 0,
                          textIndent: "0in",
                          marginRight: "0.01in",
                          border: "none",
                          padding: "0in",
                        }}
                      >
                        <font face="Arial, sans-serif">
                          <font face="Times New Roman, serif">
                            The date of each Disclosure;
                          </font>
                        </font>
                      </p>
                    </li>
                    <li>
                      <p
                        className="western text-justify"
                        align="justify"
                        style={{
                          lineHeight: "100%",
                          orphans: 0,
                          widows: 0,
                          textIndent: "0in",
                          marginRight: "0.01in",
                          border: "none",
                          padding: "0in",
                        }}
                      >
                        <font face="Arial, sans-serif">
                          <font face="Times New Roman, serif">
                            The name and address of the organization or person
                            to whom the Protected Health Information was
                            Disclosed;
                          </font>
                        </font>
                      </p>
                    </li>
                    <li>
                      <p
                        className="western text-justify"
                        align="justify"
                        style={{
                          lineHeight: "100%",
                          orphans: 0,
                          widows: 0,
                          textIndent: "0in",
                          marginRight: "0.01in",
                          border: "none",
                          padding: "0in",
                        }}
                      >
                        <font face="Arial, sans-serif">
                          <font face="Times New Roman, serif">
                            A brief description of the information Disclosed;
                            and
                          </font>
                        </font>
                      </p>
                    </li>
                    <li>
                      <p
                        className="western text-justify"
                        align="justify"
                        style={{
                          lineHeight: "100%",
                          orphans: 0,
                          widows: 0,
                          textIndent: "0in",
                          marginRight: "0.01in",
                          border: "none",
                          padding: "0in",
                        }}
                      >
                        <font face="Arial, sans-serif">
                          <font face="Times New Roman, serif">
                            Disclosures, other than those made at the request of
                            the Individual, the purpose for which the
                            information was Disclosed or a copy of the request
                            or authorization for Disclosure.
                          </font>
                        </font>
                      </p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p
                    className="western text-justify"
                    align="justify"
                    style={{
                      lineHeight: "100%",
                      orphans: 0,
                      widows: 0,
                      textIndent: "0in",
                      marginRight: "0.01in",
                      border: "none",
                      padding: "0in",
                    }}
                  >
                    <font face="Arial, sans-serif">
                      <font face="Times New Roman, serif">
                        Business Associate will provide the above accounting to
                        Covered Entity as promptly as possible, but in any event
                        no later than thirty (30) days after Covered Entity’s
                        request therefore. Business Associate shall provide for
                        a means of accounting for Disclosures for as long as
                        Business Associate maintains Protected Health
                        Information received from or on behalf of Covered
                        Entity.
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    className="western text-justify"
                    align="justify"
                    style={{
                      lineHeight: "100%",
                      orphans: 0,
                      widows: 0,
                      textIndent: "0in",
                      marginRight: "0.01in",
                      border: "none",
                      padding: "0in",
                    }}
                  >
                    <font face="Arial, sans-serif">
                      <font face="Times New Roman, serif">
                        Business Associate will comply with the applicable
                        provisions of the HIPAA Security Rule, including, but
                        not limited to, implementing Administrative Safeguards,
                        Physical Safeguards, and Technical Safeguards (the “
                      </font>
                      <font face="Times New Roman, serif">
                        <b>Safeguards</b>
                      </font>
                      <font face="Times New Roman, serif">
                        ”) in accordance with HIPAA that reasonably and
                        appropriately protect the Confidentiality, Integrity,
                        and Availability of electronic Protected Health
                        Information that it creates, receives, maintains, or
                        transmits on behalf of the Covered Entity.
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    className="western text-justify"
                    align="justify"
                    style={{
                      lineHeight: "100%",
                      orphans: 0,
                      widows: 0,
                      textIndent: "0in",
                      marginRight: "0.01in",
                      border: "none",
                      padding: "0in",
                    }}
                  >
                    <font face="Arial, sans-serif">
                      <font face="Times New Roman, serif">
                        Business Associate will make its policies, procedures,
                        and documentation relating to the Safeguards available
                        to the Secretary of DHHS for purposes of determining
                        Covered Entity’s compliance with HIPAA.
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    className="western text-justify"
                    align="justify"
                    style={{
                      lineHeight: "100%",
                      orphans: 0,
                      widows: 0,
                      textIndent: "0in",
                      marginRight: "0.01in",
                      border: "none",
                      padding: "0in",
                    }}
                  >
                    <font face="Arial, sans-serif">
                      <font face="Times New Roman, serif">
                        Business Associate will request and Use or Disclose only
                        the minimum amount of Protected Health Information
                        necessary to serve the intended purposes of this BAA.
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    className="western text-justify"
                    align="justify"
                    style={{
                      lineHeight: "100%",
                      orphans: 0,
                      widows: 0,
                      textIndent: "0in",
                      marginRight: "0.01in",
                      border: "none",
                      padding: "0in",
                    }}
                  >
                    <font face="Arial, sans-serif">
                      <font face="Times New Roman, serif">
                        Business Associate will not export Protected Health
                        Information, nor permit subcontractors or agents to
                        export Protected Health Information beyond the borders
                        of the United States of America.
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    className="western text-justify"
                    align="justify"
                    style={{
                      lineHeight: "100%",
                      orphans: 0,
                      widows: 0,
                      textIndent: "0in",
                      marginRight: "0.01in",
                      border: "none",
                      padding: "0in",
                    }}
                  >
                    <font face="Arial, sans-serif">
                      <font face="Times New Roman, serif">
                        Business Associate shall report promptly to Covered
                        Entity any successful Security Incident within five (5)
                        business days of Business Associate becoming aware of,
                        or should have become aware of by exercising reasonable
                        diligence, such Security Incident; provided, however,
                        that with respect to attempted unauthorized access, Use,
                        Disclosure, modification, or destruction of information
                        or interference with system operations in an information
                        system affecting electronic Protected Health
                        Information, such report to Covered Entity will be made
                        available upon request.
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    className="western text-justify"
                    align="justify"
                    style={{
                      lineHeight: "100%",
                      orphans: 0,
                      widows: 0,
                      textIndent: "0in",
                      marginRight: "0.01in",
                      border: "none",
                      padding: "0in",
                    }}
                  >
                    <font face="Arial, sans-serif">
                      <font face="Times New Roman, serif">
                        To the extent Business Associate is to carry out any
                        obligation of Covered Entity required by HIPAA, Business
                        Associate will comply with all HIPAA requirements that
                        apply to Covered Entity in the performance of such
                        obligation.
                      </font>
                    </font>
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <p
                className="western text-justify"
                align="justify"
                style={{
                  lineHeight: "100%",
                  orphans: 0,
                  widows: 0,
                  textIndent: "0in",
                  marginRight: "0.01in",
                  border: "none",
                  padding: "0in",
                }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    <u>
                      <b>Duties of Covered Entity.</b>
                    </u>
                  </font>
                  <font face="Times New Roman, serif">
                    <b></b>
                  </font>
                  <font face="Times New Roman, serif">
                    Covered Entity agrees to comply in all respects with HIPAA
                    when Using or Disclosing Protected Health Information
                    including:
                  </font>
                </font>
              </p>
              <ol type="a">
                <li>
                  <p
                    className="western text-justify"
                    align="justify"
                    style={{
                      lineHeight: "100%",
                      orphans: 0,
                      widows: 0,
                      textIndent: "0in",
                      marginRight: "0.01in",
                      border: "none",
                      padding: "0in",
                    }}
                  >
                    <font face="Arial, sans-serif">
                      <font face="Times New Roman, serif">
                        Provide Business Associate with any changes in, or
                        revocation of, permission by Individual to Use or
                        Disclose Protected Health Information, if such changes
                        affect Business Associate’s permitted or required Uses
                        and Disclosures;
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    className="western text-justify"
                    align="justify"
                    style={{
                      lineHeight: "100%",
                      orphans: 0,
                      widows: 0,
                      textIndent: "0in",
                      marginRight: "0.01in",
                      border: "none",
                      padding: "0in",
                    }}
                  >
                    <font face="Arial, sans-serif">
                      <font face="Times New Roman, serif">
                        Notify Business Associate of any restriction to the Use
                        or Disclosure of Protected Health Information that
                        Covered Entity has agreed to in accordance with HIPAA;
                        and
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    className="western text-justify"
                    align="justify"
                    style={{
                      lineHeight: "100%",
                      orphans: 0,
                      widows: 0,
                      textIndent: "0in",
                      marginRight: "0.01in",
                      border: "none",
                      padding: "0in",
                    }}
                  >
                    <font face="Arial, sans-serif">
                      <font face="Times New Roman, serif">
                        Not request Business Associate to Use or Disclose
                        Protected Health Information in any manner that would
                        not be permissible under HIPAA if done by Covered
                        Entity, unless such Use or Disclosure is included in the
                        Services to be performed pursuant to this BAA and is for
                        data aggregation or management and administrative
                        activities of Business Associate.
                      </font>
                    </font>
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <p
                className="western text-justify"
                align="justify"
                style={{
                  lineHeight: "100%",
                  orphans: 0,
                  widows: 0,
                  textIndent: "0in",
                  marginRight: "0.01in",
                  border: "none",
                  padding: "0in",
                }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    <u>
                      <b>
                        Remedies Upon Breach of any Protected Health
                        Information.
                      </b>
                    </u>
                  </font>
                  <font face="Times New Roman, serif">
                    <b></b>
                  </font>
                  <font face="Times New Roman, serif">
                    Upon a suspected Breach of any Protected Health Information
                    being held by Business Associate, Business Associate must
                    notify Covered Entity within five (5) business days of
                    Business Associate discovering such Breach, or of when
                    Business Associate should have discovered such Breach by
                    exercising reasonable diligence.
                  </font>
                </font>
              </p>
              <ol type="a">
                <li>
                  <p
                    className="western text-justify"
                    align="justify"
                    style={{
                      lineHeight: "100%",
                      orphans: 0,
                      widows: 0,
                      textIndent: "0in",
                      marginRight: "0.01in",
                      border: "none",
                      padding: "0in",
                    }}
                  >
                    <font face="Arial, sans-serif">
                      <font face="Times New Roman, serif">
                        Such notice must at least:
                      </font>
                    </font>
                  </p>
                  <ol type="i">
                    <li>
                      <p
                        className="western text-justify"
                        align="justify"
                        style={{
                          lineHeight: "100%",
                          orphans: 0,
                          widows: 0,
                          textIndent: "0in",
                          marginRight: "0.01in",
                          border: "none",
                          padding: "0in",
                        }}
                      >
                        <font face="Arial, sans-serif">
                          <font face="Times New Roman, serif">
                            Identify the nature of the non-permitted or
                            violating Use or Disclosure;
                          </font>
                        </font>
                      </p>
                    </li>
                    <li>
                      <p
                        className="western text-justify"
                        align="justify"
                        style={{
                          lineHeight: "100%",
                          orphans: 0,
                          widows: 0,
                          textIndent: "0in",
                          marginRight: "0.01in",
                          border: "none",
                          padding: "0in",
                        }}
                      >
                        <font face="Arial, sans-serif">
                          <font face="Times New Roman, serif">
                            Identify the Protected Health Information Used or
                            Disclosed;
                          </font>
                        </font>
                      </p>
                    </li>
                    <li>
                      <p
                        className="western text-justify"
                        align="justify"
                        style={{
                          lineHeight: "100%",
                          orphans: 0,
                          widows: 0,
                          textIndent: "0in",
                          marginRight: "0.01in",
                          border: "none",
                          padding: "0in",
                        }}
                      >
                        <font face="Arial, sans-serif">
                          <font face="Times New Roman, serif">
                            Identify who made the non-permitted or violating Use
                            or received the non-permitted or violating
                            Disclosure;
                          </font>
                        </font>
                      </p>
                    </li>
                    <li>
                      <p
                        className="western text-justify"
                        align="justify"
                        style={{
                          lineHeight: "100%",
                          orphans: 0,
                          widows: 0,
                          textIndent: "0in",
                          marginRight: "0.01in",
                          border: "none",
                          padding: "0in",
                        }}
                      >
                        <font face="Arial, sans-serif">
                          <font face="Times New Roman, serif">
                            Identify what corrective action Business Associate
                            took or will take to prevent further non-permitted
                            or violating Uses or Disclosures; and
                          </font>
                        </font>
                      </p>
                    </li>
                    <li>
                      <p
                        className="western text-justify"
                        align="justify"
                        style={{
                          lineHeight: "100%",
                          orphans: 0,
                          widows: 0,
                          textIndent: "0in",
                          marginRight: "0.01in",
                          border: "none",
                          padding: "0in",
                        }}
                      >
                        <font face="Arial, sans-serif">
                          <font face="Times New Roman, serif">
                            Identify what Business Associate did or will do to
                            mitigate any deleterious effect of the non-permitted
                            or violating Use or Disclosure.
                          </font>
                        </font>
                      </p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p
                    className="western text-justify"
                    align="justify"
                    style={{
                      lineHeight: "100%",
                      orphans: 0,
                      widows: 0,
                      textIndent: "0in",
                      marginRight: "0.01in",
                      border: "none",
                      padding: "0in",
                    }}
                  >
                    <font face="Arial, sans-serif">
                      <font face="Times New Roman, serif">
                        Covered Entity, at its option, may further require
                        Business Associate to:
                      </font>
                    </font>
                  </p>
                  <ol type="i">
                    <li>
                      <p
                        className="western text-justify"
                        align="justify"
                        style={{
                          lineHeight: "100%",
                          orphans: 0,
                          widows: 0,
                          textIndent: "0in",
                          marginRight: "0.01in",
                          border: "none",
                          padding: "0in",
                        }}
                      >
                        <font face="Arial, sans-serif">
                          <font face="Times New Roman, serif">
                            Furnish to Covered Entity copies of its practices
                            and procedures and books and records to facilitate
                            Covered Entity’s mitigation of damages arising from
                            an improper Use or Disclosure by Business Associate;
                          </font>
                        </font>
                      </p>
                    </li>
                    <li>
                      <p
                        className="western text-justify"
                        align="justify"
                        style={{
                          lineHeight: "100%",
                          orphans: 0,
                          widows: 0,
                          textIndent: "0in",
                          marginRight: "0.01in",
                          border: "none",
                          padding: "0in",
                        }}
                      >
                        <font face="Arial, sans-serif">
                          <font face="Times New Roman, serif">
                            Exercise all reasonable efforts to retrieve
                            improperly Used or Disclosed Protected Health
                            Information;
                          </font>
                        </font>
                      </p>
                    </li>
                    <li>
                      <p
                        className="western text-justify"
                        align="justify"
                        style={{
                          lineHeight: "100%",
                          orphans: 0,
                          widows: 0,
                          textIndent: "0in",
                          marginRight: "0.01in",
                          border: "none",
                          padding: "0in",
                        }}
                      >
                        <font face="Arial, sans-serif">
                          <font face="Times New Roman, serif">
                            Establish and adopt new practices, policies and
                            procedures as may be reasonable and appropriate to
                            assure that Protected Health Information is not Used
                            or Disclosed in the future in violation of HIPAA;
                          </font>
                        </font>
                      </p>
                    </li>
                    <li>
                      <p
                        className="western text-justify"
                        align="justify"
                        style={{
                          lineHeight: "100%",
                          orphans: 0,
                          widows: 0,
                          textIndent: "0in",
                          marginRight: "0.01in",
                          border: "none",
                          padding: "0in",
                        }}
                      >
                        <font face="Arial, sans-serif">
                          <font face="Times New Roman, serif">
                            Comply with all auditing or reporting requests by
                            Covered Entity to demonstrate Business Associate’s
                            compliance with HIPAA; and
                          </font>
                        </font>
                      </p>
                    </li>
                    <li>
                      <p
                        className="western text-justify"
                        align="justify"
                        style={{
                          lineHeight: "100%",
                          orphans: 0,
                          widows: 0,
                          textIndent: "0in",
                          marginRight: "0.01in",
                          border: "none",
                          padding: "0in",
                        }}
                      >
                        <font face="Arial, sans-serif">
                          <font face="Times New Roman, serif">
                            Take such other actions as Covered Entity may
                            reasonably require.
                          </font>
                        </font>
                      </p>
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              <p
                className="western text-justify"
                align="justify"
                style={{
                  lineHeight: "100%",
                  orphans: 0,
                  widows: 0,
                  textIndent: "0in",
                  marginRight: "0.01in",
                  border: "none",
                  padding: "0in",
                }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    <u>
                      <b>Term; Termination.</b>
                    </u>
                  </font>
                  <font face="Times New Roman, serif">
                    <b></b>
                  </font>
                  <font face="Times New Roman, serif">
                    This BAA shall be in effect for the entire length of the
                    underlying business relationship as set forth in the
                    Services Agreement and described in paragraph 2 of this BAA.
                    This BAA may be terminated as follows:
                  </font>
                </font>
              </p>
              <ol type="a">
                <li>
                  <p
                    className="western text-justify"
                    align="justify"
                    style={{
                      lineHeight: "100%",
                      orphans: 0,
                      widows: 0,
                      textIndent: "0in",
                      marginRight: "0.01in",
                      border: "none",
                      padding: "0in",
                    }}
                  >
                    <font face="Arial, sans-serif">
                      <font face="Times New Roman, serif">
                        Upon termination of the Services Agreement.
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    className="western text-justify"
                    align="justify"
                    style={{
                      lineHeight: "100%",
                      orphans: 0,
                      widows: 0,
                      textIndent: "0in",
                      marginRight: "0.01in",
                      border: "none",
                      padding: "0in",
                    }}
                  >
                    <font face="Arial, sans-serif">
                      <font face="Times New Roman, serif">
                        Upon Covered Entity’s knowledge of a material breach of
                        this BAA by Business Associate, Covered Entity will: (i)
                        provide Business Associate with thirty (30) days in
                        which to cure the breach or end the violation and, if
                        Business Associate does not cure the breach or end the
                        violation within such time period, terminate this BAA;
                        or (ii) immediately terminate this BAA if Business
                        Associate has breached a material term of this BAA and
                        cure is not possible.
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    className="western text-justify"
                    align="justify"
                    style={{
                      lineHeight: "100%",
                      orphans: 0,
                      widows: 0,
                      textIndent: "0in",
                      marginRight: "0.01in",
                      border: "none",
                      padding: "0in",
                    }}
                  >
                    <font face="Arial, sans-serif">
                      <font face="Times New Roman, serif">
                        Business Associate may terminate this BAA if it makes
                        the determination that a material condition of
                        performance has changed under this BAA, or that Covered
                        Entity has breached a material term of this BAA.
                      </font>
                    </font>
                  </p>
                </li>
                <li>
                  <p
                    className="western text-justify"
                    align="justify"
                    style={{
                      lineHeight: "100%",
                      orphans: 0,
                      widows: 0,
                      textIndent: "0in",
                      marginRight: "0.01in",
                      border: "none",
                      padding: "0in",
                    }}
                  >
                    <font face="Arial, sans-serif">
                      <font face="Times New Roman, serif">
                        Upon termination of this BAA or the Services Agreement,
                        which sets forth the underlying business relationship,
                        for any reason, Business Associate will within thirty
                        (30) business days of the effective date of the
                        termination notice return all Protected Health
                        Information received from Covered Entity or created by
                        Business Associate on behalf of Covered Entity. If such
                        return or destruction is not feasible, Business
                        Associate will extend the protections of this BAA to
                        such Protected Health Information and will limit further
                        uses and disclosures of such information to those
                        purposes which make the return or destruction of such
                        information infeasible.
                      </font>
                    </font>
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <p
                className="western text-justify"
                align="justify"
                style={{
                  lineHeight: "100%",
                  orphans: 0,
                  widows: 0,
                  textIndent: "0in",
                  marginRight: "0.01in",
                  marginBottom: "0.17in",
                  border: "none",
                  padding: "0in",
                }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    <u>
                      <b>Change of Law.</b>
                    </u>
                  </font>
                  <font face="Times New Roman, serif">
                    <b> </b>
                  </font>
                  <font face="Times New Roman, serif">
                    In the event any state or federal laws or regulations now
                    existing or enacted or promulgated after the effective date
                    of this BAA, are interpreted by judicial decision, a
                    regulatory agency or legal counsel to a party hereto in such
                    a manner as to indicate that any provision of this BAA may
                    be in violation of such laws or regulations, the parties may
                    amend this BAA as necessary to comply with such laws and
                    regulations. To the maximum extent possible, any such
                    amendment shall preserve the underlying rights, duties and
                    obligations established in this BAA.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <h2
                className="western text-justify"
                align="justify"
                style={{
                  textIndent: "0in",
                  marginRight: "0.01in",
                  marginTop: "0in",
                  marginBottom: "0.17in",
                }}
              >
                <font face="Times New Roman, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <u>General Provisions.</u>
                  </font>
                </font>
              </h2>
              <ol type="a">
                <li>
                  <p
                    className="western text-justify"
                    align="justify"
                    style={{
                      lineHeight: "100%",
                      orphans: 0,
                      widows: 0,
                      textIndent: "0in",
                      marginRight: "0.01in",
                      border: "none",
                      padding: "0in",
                    }}
                  >
                    <font face="Arial, sans-serif">
                      <font face="Times New Roman, serif">
                        <u>
                          <b>Limitation of Liability.</b>
                        </u>
                      </font>
                      <font face="Times New Roman, serif">
                        <b></b>
                      </font>
                      <font face="Times New Roman, serif">
                        NOTWITHSTANDING ANYTHING TO THE CONTRARY HEREIN,
                        BUSINESS ASSOCIATE’S TOTAL LIABILITY ARISING OUT OF OR
                        RELATING TO THIS AGREEMENT FOR ANY CLAIMS OF ANY NATURE
                        WILL NOT EXCEED THE AMOUNT OF FEES RECEIVED BY BUSINESS
                        ASSOCIATE UNDER THE SERVICES AGREEMENT WHICH SETS FORTH
                        THE UNDERLYING ARRANGEMENT DURING THE PRECEDING TWELVE
                        (12) MONTH PERIOD. IN NO EVENT WILL BUSINESS ASSOCIATE
                        BE LIABLE FOR ANY INDIRECT, SPECIAL, EXEMPLARY,
                        INCIDENTAL, CONSEQUENTIAL OR PUNITIVE DAMAGES ARISING
                        OUT OF OR RELATED TO THIS BAA OR THE BREACH THEREOF,
                        INCLUDING, WITHOUT LIMITATION, LOST PROFITS, LOST DATA,
                        BUSINESS INTERRUPTION OR OTHER ECONOMIC LOSS. THE
                        LIMITATION OF LIABILITY SET FORTH IN THIS SECTION 9(a)
                        WILL APPLY EVEN IF COVERED ENTITY HAS BEEN ADVISED OF
                        THE POSSIBILITY OF SUCH DAMAGES AND SHALL SURVIVE ANY
                        TERMINATION OF THIS BAA.
                      </font>
                    </font>
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <p
                className="western text-justify"
                align="justify"
                style={{
                  lineHeight: "100%",
                  orphans: 0,
                  widows: 0,
                  textIndent: "0in",
                  marginRight: "0.01in",
                  border: "none",
                  padding: "0in",
                }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    <u>
                      <b>Notices.</b>
                    </u>
                  </font>
                  <font face="Times New Roman, serif">
                    <b></b>
                  </font>
                  <font face="Times New Roman, serif">
                    Any and all notices or other communications required or
                    permitted to be given under any of the provisions of this
                    BAA shall be in writing and shall be deemed to have been
                    delivered when given in the manner set forth below to the
                    address indicated on the signature page. Counsel to a party
                    may give notice on behalf of a party. Such communications
                    shall be deemed to have been given (a) three days after
                    mailing, when mailed by registered or certified postage-paid
                    mail, (b) on the next business day, when delivered by a
                    same-day or overnight national courier service or the U.S.
                    Post Office Express Mail or (c) upon the date of receipt by
                    the addressees when delivered personally or by fax. A party
                    must receive a notice of change of address for it to be
                    effective.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                className="western text-justify"
                align="justify"
                style={{
                  lineHeight: "100%",
                  orphans: 0,
                  widows: 0,
                  textIndent: "0in",
                  marginRight: "0.01in",
                  border: "none",
                  padding: "0in",
                }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    <u>
                      <b>Entire Agreement; Amendment.</b>
                    </u>
                  </font>
                  <font face="Times New Roman, serif">
                    <b></b>
                  </font>
                  <font face="Times New Roman, serif">
                    This BAA constitutes the entire and only agreement of the
                    parties with respect to HIPAA and supersedes any and all
                    prior negotiations, understandings and agreements concerning
                    the obligations regarding the Use and Disclosure of
                    Protected Health Information; provided, however, if any
                    written agreement between the parties imposes obligations
                    and restrictions on Business Associate regarding Protected
                    Health Information over and above those imposed by this
                    agreement, those obligations and restrictions are not
                    superseded hereby and shall survive. This BAA may be
                    amended, modified, superseded, canceled, renewed or extended
                    only by a written instrument executed by the parties herein.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                className="western text-justify"
                align="justify"
                style={{
                  lineHeight: "100%",
                  orphans: 0,
                  widows: 0,
                  textIndent: "0in",
                  marginRight: "0.01in",
                  border: "none",
                  padding: "0in",
                }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    <u>
                      <b>Waiver.</b>
                    </u>
                  </font>
                  <font face="Times New Roman, serif">
                    <b></b>
                  </font>
                  <font face="Times New Roman, serif">
                    The failure by any party at any time to require performance
                    or compliance by another of any of its obligations or
                    agreements shall in no way affect the right to require such
                    performance or compliance at any time thereafter. The waiver
                    by any party of a breach of any provision hereof shall not
                    be taken or held to be a waiver of any preceding or
                    succeeding breach of such provision or as a waiver of the
                    provision itself. No waiver of any kind shall be effective
                    or binding, unless it is in writing and is signed by the
                    party against which such waiver is sought to be enforced.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                className="western text-justify"
                align="justify"
                style={{
                  lineHeight: "100%",
                  orphans: 0,
                  widows: 0,
                  textIndent: "0in",
                  marginRight: "0.01in",
                  border: "none",
                  padding: "0in",
                }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    <u>
                      <b>Binding Nature.</b>
                    </u>
                  </font>
                  <font face="Times New Roman, serif">
                    <b> </b>
                  </font>
                  <font face="Times New Roman, serif">
                    This BAA shall be binding upon and inure to the benefit of
                    each party hereto, its successors and permitted assigns.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                className="western text-justify"
                align="justify"
                style={{
                  lineHeight: "100%",
                  orphans: 0,
                  widows: 0,
                  textIndent: "0in",
                  marginRight: "0.01in",
                  border: "none",
                  padding: "0in",
                }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    <u>
                      <b>Assignment.</b>
                    </u>
                  </font>
                  <font face="Times New Roman, serif">
                    <b></b>
                  </font>
                  <font face="Times New Roman, serif">
                    Neither party may assign or otherwise transfer its rights or
                    obligations under this BAA, by operation of law or
                    otherwise, without the prior written consent of the other
                    party to this BAA; provided, however, that either party may
                    assign this BAA to the surviving party in a merger of that
                    party into another entity or in an acquisition of all or
                    substantially all its assets. No assignment becomes
                    effective unless and until the assignee agrees in writing to
                    be bound by this BAA, without modification, and all the
                    assigning parties obligations under this BAA. The provisions
                    of this BAA will be binding upon and will inure to the
                    benefit of the parties’ successors and permitted assigns,
                    respectively, but this provision will not constitute a
                    consent by either party to assignment by the other party
                    otherwise prohibited.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                className="western text-justify"
                align="justify"
                style={{
                  lineHeight: "100%",
                  orphans: 0,
                  widows: 0,
                  textIndent: "0in",
                  marginRight: "0.01in",
                  border: "none",
                  padding: "0in",
                }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    <u>
                      <b>Captions; Language.</b>
                    </u>
                  </font>
                  <font face="Times New Roman, serif">
                    <b> </b>
                  </font>
                  <font face="Times New Roman, serif">
                    The section headings contained in this BAA are for the
                    purposes of convenience only and are not intended to define
                    or limit the contents of such sections. In this BAA, unless
                    the context requires otherwise, the singular includes the
                    plural, the plural the singular, and the word “or” is used
                    in the inclusive sense.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                className="western text-justify"
                align="justify"
                style={{
                  lineHeight: "100%",
                  orphans: 0,
                  widows: 0,
                  textIndent: "0in",
                  marginRight: "0.01in",
                  border: "none",
                  padding: "0in",
                }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    <u>
                      <b>Counterparts.</b>
                    </u>
                  </font>
                  <font face="Times New Roman, serif">
                    <b></b>
                  </font>
                  <font face="Times New Roman, serif">
                    This BAA may be executed in one or more counterparts, all of
                    which taken together shall be deemed to evidence one and the
                    same agreement.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                className="western text-justify"
                align="justify"
                style={{
                  lineHeight: "100%",
                  orphans: 0,
                  widows: 0,
                  textIndent: "0in",
                  marginRight: "0.01in",
                  border: "none",
                  padding: "0in",
                }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    <u>
                      <b>Applicable Law.</b>
                    </u>
                  </font>
                  <font face="Times New Roman, serif">
                    <b> </b>
                  </font>
                  <font face="Times New Roman, serif">
                    This BAA and its validity, construction, and performance
                    shall be governed in all respects by the laws of the State
                    of California and by HIPAA. In the event of any action or
                    proceeding arising under this BAA, the parties’ consent and
                    agree that the forum for such action shall be in a court of
                    competent jurisdiction located in Los Angeles County,
                    California.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                className="western text-justify"
                align="justify"
                style={{
                  lineHeight: "100%",
                  orphans: 0,
                  widows: 0,
                  textIndent: "0in",
                  marginRight: "0.01in",
                  marginBottom: "0.17in",
                  border: "none",
                  padding: "0in",
                }}
              >
                <font face="Arial, sans-serif">
                  <font face="Times New Roman, serif">
                    <u>
                      <b>Independent Contractor</b>
                    </u>
                  </font>
                  <font face="Times New Roman, serif">
                    <b>.</b>
                  </font>
                  <font face="Times New Roman, serif">
                    None of the provisions of this BAA are intended to create
                    any relationship between the parties other than that of
                    independent entities contracting with each other for the
                    purpose of effecting the provisions of this BAA.
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <p
            className="western text-justify"
            align="justify"
            style={{
              lineHeight: "100%",
              orphans: 0,
              widows: 0,
              textIndent: "-0in",
              marginLeft: "0in",
              marginRight: "0.07in",
              marginBottom: "0.17in",
              border: "none",
              padding: "0in",
            }}
          >
            <font face="Arial, sans-serif">
              <font face="Times New Roman, serif">
                <b>IN WITNESS WHEREOF, </b>
              </font>
              <font face="Times New Roman, serif">
                the parties have executed this BAA as of the day and year first
                above written.
              </font>
            </font>
          </p>

          <GFEForm
            signImage={signImage}
            data={data}
            isFirstSign={false}
            filledSignatureIds={filledSignatureIds}
            setFilledSignatureIds={setFilledSignatureIds}
          />
        </>
        <SignatureModal
          isLoading={loading}
          defaultName={data?.data?.signers[0]?.name}
          signatureType={signType}
          onSubmit={(signedDoc, type) => uploadSignatureFile(signedDoc)}
          onClose={handleModalClose}
          open={open}
        />
      </div>
    </div>
  );
};

export default QualiphyServiceAgreement;
